export default {
  "ApiErrorCode.40001001": "Invalid verification code",
  "ApiErrorCode.40001004":
    "This user is a root user in the organization, it cannot be disabled",
  "ApiErrorCode.40001005":
    "Unable to retrieve account information using the email address",
  "ApiErrorCode.101101001": "Organization does not exist",
  "ApiErrorCode.101101002": "Organization name already exists",
  "ApiErrorCode.101101003": "Organization creation failed, please try again",
  "ApiErrorCode.101101004": "Reset appSecret failed, please try again",
  "ApiErrorCode.101101005": "Organization creation failed, please try again",
  "ApiErrorCode.101101006": "Organization creation failed, please try again",
  "ApiErrorCode.101101008": "Tenant user email already exists",
  "ApiErrorCode.101101009": "Organization activation failed, please try again",
  "ApiErrorCode.101101010": "Disable organization failed, please try again",
  "ApiErrorCode.101101011": "Resend activation link failed, please try again",
  "ApiErrorCode.101101012": "Operation is too frequent, please try again",
  "ApiErrorCode.101101015": "Tenant user update failed",
  "ApiErrorCode.101101016": "Organization activated",
  "ApiErrorCode.101101017": "Organization not activated yet",
  "ApiErrorCode.101101018": "Organization enabled",
  "ApiErrorCode.101101019": "Organization disabled",
  "ApiErrorCode.101101020": "Organization contract renewal failed",
  "ApiErrorCode.101102001": "User does not exist",
  "ApiErrorCode.101102002": "User already exists",
  "ApiErrorCode.101102003": "User account disabled",
  "ApiErrorCode.101102004": "Reset link has expired",
  "ApiErrorCode.101102005": "Activation link has expired",
  "ApiErrorCode.101102006": "Operation failed, please try again later",
  "ApiErrorCode.101102007": "Email cannot be empty",
  "ApiErrorCode.101102008": "Link has expired",
  "ApiErrorCode.101102009": "User information mismatch",
  "ApiErrorCode.101102010": "No operation permission",
  "ApiErrorCode.101102011": "Super admins cannot be edited",
  "ApiErrorCode.101102012": "Update failed",
  "ApiErrorCode.101102013": "Operation failed, please try again later",
  "ApiErrorCode.101102014":
    "Creating super admins through the API is not permitted",
  "ApiErrorCode.101102016": "Internal management system user activated",
  "ApiErrorCode.101103001": "Account does not exist",
  "ApiErrorCode.101103002": "Account password update failed",
  "ApiErrorCode.101105001": "Email sending error, please try again later",
  "ApiErrorCode.101105002": "Email sending error, please try again later",
  "ApiErrorCode.101105003": "Email authentication code error",
  "ApiErrorCode.101109001":
    "An error occurred while creating the announcement, please check parameters entered",
  "ApiErrorCode.101109002":
    "Announcement end time must be greater than start time and current time",
  "ApiErrorCode.202101001": "User does not exist",
  "ApiErrorCode.202101002": "User already exists",
  "ApiErrorCode.202101004": "MFA decryption failed",
  "ApiErrorCode.202101005": "MFA encryption failed",
  "ApiErrorCode.202101007": "MFA SharedSecret is missing",
  "ApiErrorCode.202101008": "MFA binding failed, please try again later",
  "ApiErrorCode.202101009": "MFA security code error",
  "ApiErrorCode.202101010": "MFA security code error",
  "ApiErrorCode.202101011": "MFA security code error",
  "ApiErrorCode.202101012": "Phone number already exists",
  "ApiErrorCode.202101014": "Phone number already exists",
  "ApiErrorCode.202101015": "This account is not linked to any organization",
  "ApiErrorCode.202101017": "Operation timeout, please try again later",
  "ApiErrorCode.202101018": "Organization disabled",
  "ApiErrorCode.202102001": "User creation failed, please contact an admin",
  "ApiErrorCode.202102002": "User already exists",
  "ApiErrorCode.202102003": "Super admins cannot be edited",
  "ApiErrorCode.202102004":
    "Upgrading to super admin using the employee API is not permitted",
  "ApiErrorCode.202103001": "Role does not exist",
  "ApiErrorCode.202103002": "Role name already exists",
  "ApiErrorCode.202103003": "Role creation failed",
  "ApiErrorCode.202103004": "Role update failed",
  "ApiErrorCode.202103005":
    "Some permission sets cannot be assigned. Please check the data and try again.",
  "ApiErrorCode.202103006": "Default roles cannot be modified",
  "ApiErrorCode.202103007": "You can create up to 30 roles",
  "ApiErrorCode.202103008":
    "Incorrect permission set type. Please check the data and try again",
  "ApiErrorCode.202103009":
    "The permission set does not exist. Please check the data and try again",
  "ApiErrorCode.202103010": "Duplicate key permission set",
  "ApiErrorCode.202104001": "User activation failed, please contact an admin",
  "ApiErrorCode.202104002": "User activated",
  "ApiErrorCode.202104003": "User does not exist, please contact the admin",
  "ApiErrorCode.202104004": "User activation failed. Invalid activation link",
  "ApiErrorCode.202104005": "User activation failed, please contact an admin",
  "ApiErrorCode.202104006": "User deletion failed, please try again later",
  "ApiErrorCode.202104007":
    "Creating super admins through the API is not permitted",
  "ApiErrorCode.202104012": "Super admins cannot be deleted",
  "ApiErrorCode.202104013":
    "The current account is a super admin in the linked tenant. Please check the linked tenant",
  "ApiErrorCode.202105001": "Operation is too frequent, please try again later",
  "ApiErrorCode.202105002":
    "Verification code sending error, please try again later",
  "ApiErrorCode.202105003": "Invalid verification code, please check",
  "ApiErrorCode.202105004":
    "Input error email verification code too many times, please resend verification code",
  "ApiErrorCode.202106001": "CDN not yet configured.",
  "ApiErrorCode.202106002":
    "Domain name ownership verification failed, please try again later",
  "ApiErrorCode.202106003": "Incomplete domain name ownership verification",
  "ApiErrorCode.202106005": "Illegal domain name",
  "ApiErrorCode.202106006": "Domain name not registered",
  "ApiErrorCode.202106007":
    "Domain name ownership verification failed, please try again later",
  "ApiErrorCode.202106008":
    "CNAME domain name binding failed, please try again later",
  "ApiErrorCode.202106009": "Domain name already exists",
  "ApiErrorCode.202106010": "Domain name does not exist",
  "ApiErrorCode.202106011": "Invalid certificate format",
  "ApiErrorCode.202106012": "Certificate does not exist",
  "ApiErrorCode.202106013": "Certificate mismatch",
  "ApiErrorCode.202106014": "Certificate already exists",
  "ApiErrorCode.202106015": "CDN service error, please contact an admin",
  "ApiErrorCode.202106016": "CDN domain name already taken, please change it",
  "ApiErrorCode.202106017": "CDN configuration in progress, please wait",
  "ApiErrorCode.202106020":
    "Mismatching certificate, please provide domain name certificate",
  "ApiErrorCode.202106021":
    "Domain name CNAME configured, please clear DNS record.",
  "ApiErrorCode.202106022": "CDN domain advanced configuration error",
  "ApiErrorCode.202107001": "Request parameter error",
  "ApiErrorCode.202107002": "Invalid query parameter",
  "ApiErrorCode.202108001":
    "Invalid verification code. Please check your input and try again.",
  "ApiErrorCode.202108002":
    "Invalid verification code. Please check your input and try again.",
  "ApiErrorCode.202108003":
    "Invalid verification code. Please check your input and try again.",
  "ApiErrorCode.202108004":
    "Failed to create Open API key pair. Please try again later.",
  "ApiErrorCode.202108005":
    "You have already created the maximum number of Open API key pairs. Each user can create a maximum of 10. You will need to delete existing key pairs if you want to make more.",
  "ApiErrorCode.202108006":
    "The Open API key pair data you selected does not exist. Check your network connection and try again.",
  "ApiErrorCode.202108007":
    "The phone number linked to your account does not exist. Please contact your organization's administrator to check the status of your account.",
  "ApiErrorCode.202108008":
    "Failed to update your Open API key pair status. Please retry later.",
  "ApiErrorCode.202108009":
    "Failed to delete your Open API key pair. Please retry later.",
  "ApiErrorCode.202108010":
    "During CDN configuration, it's been discovered that the maximum number of domains has been reached",
  "ApiErrorCode.202110001": "Audit log query exceeds maximum time range",
  "ApiErrorCode.202111001": "Base configuration is not completed",
  "ApiErrorCode.202111002": "Client_password must be entered",
  "ApiErrorCode.202111003": "Base config create error",
  "ApiErrorCode.202111004": "Base config update error",
  "ApiErrorCode.202111005": "API version does not exist",
  "ApiErrorCode.202111006": "Base configuration authentication error",
  "ApiErrorCode.202111007": "No permissions for the base configuration",
  "ApiErrorCode.202111008": "Invalid sync Task ID",
  "ApiErrorCode.202111009": "Sync task does not exist",
  "ApiErrorCode.202111010": "Failed to create sync task",
  "ApiErrorCode.202111011": 'Only one task per object can be "enabled"',
  "ApiErrorCode.202111012": "Failed to update sync task",
  "ApiErrorCode.202111013": "Only disabled tasks can be edited",
  "ApiErrorCode.202111014":
    "Only disabled synchronization tasks can be deleted",
  "ApiErrorCode.202111015": "Failed to obtain category",
  "ApiErrorCode.202111018": "Failed to obtain sites",
  "ApiErrorCode.202111019": "Failed to obtain catalog",
  "ApiErrorCode.202111020": "Failed to obtain locale language",
  "ApiErrorCode.202111021": "Failed to obtain inventory",
  "ApiErrorCode.202111022": "Failed to encrypt client pass",
  "ApiErrorCode.202111023": "Failed to decrypt client pass",
  "ApiErrorCode.202112001":
    "Sorry, this CXG organization has already been connected",
  "ApiErrorCode.202112002":
    "Sorry, this Salesforce organization has already been connected to another CXG organization. Please select another Salesforce organization to connect to.",
  "ApiErrorCode.202112003": "Invalid operation",
  "ApiErrorCode.202112004":
    "Sorry, you do not have permission to operate organization connections. You can check your permissions and configuration in the Salesforce CRM.",
  "ApiErrorCode.203101001": "Webhook does not exist",
  "ApiErrorCode.203101002": "Webhook already exists",
  "ApiErrorCode.203101003": "A Webhook with this name already exists",
  "ApiErrorCode.203101004": "Webhook event type error. Please check the data.",
  "ApiErrorCode.203101005": "Please disable the webhook before editing it",
  "ApiErrorCode.203101006":
    "Health check failed. Please check the data or the server.",
  "ApiErrorCode.203101007":
    "Unable to recognize the URL configured by the Webhook",
  "ApiErrorCode.203101008":
    "Only up to two webhook tasks can be created for the same event type",
  "ApiErrorCode.203101009":
    "The URL configured by the Webhook is not in the allowed list",
  "ApiErrorCode.203101010":
    "Failed to encrypt key. Please contact the administrator.",
  "ApiErrorCode.204101001": "Store front does not exist",
  "ApiErrorCode.204101002": "Storefront already exists",
  "ApiErrorCode.204101003": "Failed to link WeChat mini-program",
  "ApiErrorCode.204101005": "Storefront AppID has been linked",
  "ApiErrorCode.204101006": "Storefront URL has been linked",
  "ApiErrorCode.204101007":
    "This channel's storefront does not support being updated",
  "ApiErrorCode.204102001": "Payment merchant does not exist",
  "ApiErrorCode.204102002": "Payment merchant already exists",
  "ApiErrorCode.204102003": "Failed to verify payment merchant",
  "ApiErrorCode.204102005":
    "This merchant is unable to receive payments. Merchants can log into the WeChat Merchant Platform/WeChat Payment Merchant Assistant mini-program to view reasons why they are unable to receive payments and how to resolve the issue.",
  "ApiErrorCode.204103001": "WeChat service error. Please try again later.",
  "ApiErrorCode.204103002": "WeChat service error. Please try again later.",
  "ApiErrorCode.204103003": "WeChat service error. Please try again later.",
  "ApiErrorCode.204105001":
    "Please check that you have entered the correct AppID and AppSecret",
  "ApiErrorCode.204105003":
    "Error adding or updating website quick login configuration. Please try again.",
  "ApiErrorCode.204106003": "Please create store first",
  "ApiErrorCode.204106005":
    "If you need to enable the review function, please select at least one order status",
  "ApiErrorCode.204106006": "Incorrect reviewable order status",
  "ApiErrorCode.204106007": "Allowlist is full. Unable to add.",
  "ApiErrorCode.204106008": "Invalid domain",
  "ApiErrorCode.204109001": "WeChat service error. Please try again later.",
  "ApiErrorCode.206101001": "Failed to create attribute",
  "ApiErrorCode.206101002": "Failed to update attribute",
  "ApiErrorCode.206101003": "Failed to delete attribute",
  "ApiErrorCode.206101004": "Attribute does not exist",
  "ApiErrorCode.206101005":
    "Attribute value already exists. Please edit it and retry.",
  "ApiErrorCode.206102001": "Associate attribute failed",
  "ApiErrorCode.206102002": "Failed to update attribute association",
  "ApiErrorCode.206102003": "Failed to cancel attribute association",
  "ApiErrorCode.206102004": "Attribute does not exist under category",
  "ApiErrorCode.206102005": "Failed to update whether to display in channel",
  "ApiErrorCode.206102006": "Associated attribute already exists",
  "ApiErrorCode.206103001": "Category creation error",
  "ApiErrorCode.206103002": "Category update error",
  "ApiErrorCode.206103003": "Category deletion error",
  "ApiErrorCode.206103004": "Category does not exist",
  "ApiErrorCode.206103005": "External category ID already exists",
  "ApiErrorCode.206103006": "Invalid parent category",
  "ApiErrorCode.206103007":
    "Failed to delete category as it still contains products",
  "ApiErrorCode.206103008":
    "Failed to delete category as there are sub-categories beneath it",
  "ApiErrorCode.206103009":
    "Failed to delete category as there is an associated product",
  "ApiErrorCode.206103010":
    "Exceeded maximum number of category levels. Creation failed.",
  "ApiErrorCode.206103011":
    "Exceeded maximum number of categories. Creation failed.",
  "ApiErrorCode.206104001": "Failed to associate specification",
  "ApiErrorCode.206104002": "Failed to update associated specification",
  "ApiErrorCode.206104003": "Failed to cancel associated specification",
  "ApiErrorCode.206104004": "Specification does not exist under category",
  "ApiErrorCode.206104005": "Failed to update whether to display in channel",
  "ApiErrorCode.206104006": "Category specification already exists",
  "ApiErrorCode.206105000": "Invalid SPU parameters",
  "ApiErrorCode.206105001": "Failed to create product. Please try again later.",
  "ApiErrorCode.206105002": "Failed to update product",
  "ApiErrorCode.206105003": "Failed to delete product",
  "ApiErrorCode.206105004": "Product does not exist",
  "ApiErrorCode.206105005": "Failed to create SKU",
  "ApiErrorCode.206105006": "Failed to update SKU",
  "ApiErrorCode.206105007": "External Product ID already exists",
  "ApiErrorCode.206105008": "Failed to cancel association",
  "ApiErrorCode.206105009":
    "Unable to edit. Please deactivate the product first.",
  "ApiErrorCode.206105010": "Invalid SKU ID",
  "ApiErrorCode.206105011": "Product cannot be activated",
  "ApiErrorCode.206105012": "SKU does not exist",
  "ApiErrorCode.206105013": "Failed to obtain inventory",
  "ApiErrorCode.206105014": "Specification does not exist in product",
  "ApiErrorCode.206105015": "Unable to delete product",
  "ApiErrorCode.206105016": "Invalid sales price",
  "ApiErrorCode.206105017": "Invalid inventory",
  "ApiErrorCode.206105019": "SKU can only generate 200 at most.",
  "ApiErrorCode.206105020":
    "Failed to activate product. At least one SKU must be in a normal state.",
  "ApiErrorCode.206105028":
    "Number of characters in the rich text editor exceed the upper limit",
  "ApiErrorCode.206105029":
    "Number of images in the rich text editor exceed the upper limit",
  "ApiErrorCode.206105030":
    "Invalid domain link exists within the rich text editor",
  "ApiErrorCode.206106001": "Failed to create specification",
  "ApiErrorCode.206106002": "Failed to update specification",
  "ApiErrorCode.206106003": "Failed to delete specification",
  "ApiErrorCode.206106004": "Category specification does not exist",
  "ApiErrorCode.206106005":
    "Duplicate specification value. Please edit and try again.",
  "ApiErrorCode.206107001": "Invalid image link",
  "ApiErrorCode.206109001": "Cannot remove gift when it's part of a promotion",
  "ApiErrorCode.206109002": "Only supports creating single-attribute gifts",
  "ApiErrorCode.206109003": "Gift SPU does not exist",
  "ApiErrorCode.206109004": "Failed to create gift SPU",
  "ApiErrorCode.206109005": "Failed to update gift SPU",
  "ApiErrorCode.206109006": "Failed to delete gift SPU",
  "ApiErrorCode.206109007": "Gift cannot be edited when it is still activated",
  "ApiErrorCode.206109008": "Cannot delete gift when it's part of a promotion",
  "ApiErrorCode.206109009": "Failed to update gift",
  "ApiErrorCode.206109010": "Gift does not exist",
  "ApiErrorCode.206109011": "Gift external ID already exists",
  "ApiErrorCode.206109012": "No SKU has been created for the gift",
  "ApiErrorCode.206109013": "Gift does not exist",
  "ApiErrorCode.206109014": "Gift cannot be edited when it is still activated",
  "ApiErrorCode.206109015": "Invalid gift SKU ID",
  "ApiErrorCode.206109016": "Cannot delete gift when it's part of a promotion",
  "ApiErrorCode.206109017": "Gift is still activated. Unable to update SKU.",
  "ApiErrorCode.207101001": "Alibaba Cloud SMS account not configured",
  "ApiErrorCode.207101002": "Failed to configure Alibaba Cloud SMS account",
  "ApiErrorCode.207101003": "Failed to delete Alibaba Cloud SMS account data",
  "ApiErrorCode.207101004":
    "The account has not activated the Alibaba Cloud SMS features or permissions",
  "ApiErrorCode.207101006": "Alibaba Cloud SMS account has not been configured",
  "ApiErrorCode.207101007": "Email STMP has not been configured",
  "ApiErrorCode.207102001": "Current event has been linked to this template",
  "ApiErrorCode.207102003": "Current event cannot be linked to this template",
  "ApiErrorCode.207102004": "Failed to link event and template",
  "ApiErrorCode.207102005": "Failed to update linking status",
  "ApiErrorCode.207102006": "Failed to update linking data",
  "ApiErrorCode.207102007": "Failed to obtain linking configuration",
  "ApiErrorCode.207103001": "Signature data does not exist",
  "ApiErrorCode.207103002": "SMS signature name already exists",
  "ApiErrorCode.207103003": "SMS signature name does not exist",
  "ApiErrorCode.207103004": "Failed to add SMS signature",
  "ApiErrorCode.207103005": "Failed to deleted SMS signature",
  "ApiErrorCode.207104001": "SMS template includes unsupported variables",
  "ApiErrorCode.207104002": "SMS template does not exist or is not enabled",
  "ApiErrorCode.207104003": "An SMS template with this name already exists",
  "ApiErrorCode.207104004": "SMS template cannot be edited",
  "ApiErrorCode.207104005": "Failed to update SMS template",
  "ApiErrorCode.207104006": "Failed to delete SMS template",
  "ApiErrorCode.207104007": "Failed to create SMS template",
  "ApiErrorCode.207104010": "Template linking variable error",
  "ApiErrorCode.207104011": "Template linking variable cannot be blank",
  "ApiErrorCode.207106001": "Request for Alibaba Cloud API failed.",
  "ApiErrorCode.207107001":
    "Sending SMS messages too frequently. Please try again later.",
  "ApiErrorCode.207107002":
    "Failed to send security SMS, please try again later",
  "ApiErrorCode.207107003":
    "Security SMS verification failed, invalid verification code",
  "ApiErrorCode.207107004": "Security SMS configuration is missing",
  "ApiErrorCode.207107005": "Trigger sending SMS limit flow control",
  "ApiErrorCode.207108001":
    "Sending emails too frequently. Please try again later.",
  "ApiErrorCode.207108002": "Failed to send email verification code",
  "ApiErrorCode.207108004": "Platform email configuration missing",
  "ApiErrorCode.207108005": "Invalid Alibaba Cloud signature type",
  "ApiErrorCode.207108006": "Invalid Alibaba Cloud SMS template type",
  "ApiErrorCode.207108007": "SMS template does not exist",
  "ApiErrorCode.207108008":
    "SMS template has not yet failed approval. Cannot be updated.",
  "ApiErrorCode.207108009": "Cannot delete SMS template in current status",
  "ApiErrorCode.207108010": "Failed to sync signatures from Alibaba Cloud",
  "ApiErrorCode.207108011": "Failed to sync SMS templates from Alibaba Cloud",
  "ApiErrorCode.207109001": "SMTP email configuration does not exist",
  "ApiErrorCode.207109002":
    "Failed to send test email. Check the SMTP configuration.",
  "ApiErrorCode.210101008": "Cannot edit in this order status",
  "ApiErrorCode.210101009": "Failed to update some order information",
  "ApiErrorCode.211101001":
    "Please upload an image in one of the following formats: jpg, png, gif, tif, bmp, or svg",
  "ApiErrorCode.211101002": "Upload failed",
  "ApiErrorCode.211101003": "Failed to upload file. Configure CDN first.",
  "ApiErrorCode.211101004": "Failed to generate mini-program QR code",
  "ApiErrorCode.211101005":
    "URL and CDN domain do not match. Failed to upload file.",
  "ApiErrorCode.211101006":
    "Unable to obtain CDN domain. Failed to upload file.",
  "ApiErrorCode.211101007":
    "Image size must be between 1 KB and 5 MB. Failed to upload image.",
  "ApiErrorCode.211101008":
    "Unable to download remote file. Failed to upload file.",
  "ApiErrorCode.211101009": "File format invalid. Failed to upload file.",
  "ApiErrorCode.211101010": "File content invalid. Failed to upload file.",
  "ApiErrorCode.211101011": "Failed to upload video cover",
  "ApiErrorCode.211101012": "Failed to upload video",
  "ApiErrorCode.211101013":
    "Video size must be between 1 KB to 200 MB. Failed to upload video.",
  "ApiErrorCode.211101014": "Video content invalid. Failed to upload video.",
  "ApiErrorCode.211101015": "Invalid parameters",
  "ApiErrorCode.211101016":
    "Unable to add URL. Ensure URL has been added to the allowlist.",
  "ApiErrorCode.211101018":
    "Unable to add URL. Ensure URL has been added to the allowlist.",
  "ApiErrorCode.211101019": "Video does not exist",
  "ApiErrorCode.211102001": "Failed to upload video. Failed to transcode.",
  "ApiErrorCode.211103001": "Error. Failed to save material.",
  "ApiErrorCode.211104001": "Failed to create Aliyun policy",
  "ApiErrorCode.211104002": "Invalid contentType",
  "ApiErrorCode.211104003": "Invalid business system",
  "ApiErrorCode.211104004": "Invalid file IDs exist",
  "ApiErrorCode.211104005": "Aliyun policy is invalid or expired",
  "ApiErrorCode.211104006": "Invalid signature or Aliyun policy",
  "ApiErrorCode.211104008": "Unable to verify file",
  "ApiErrorCode.211104009": "File is being verified",
  "ApiErrorCode.211104011": "File does not exist",
  "ApiErrorCode.211104012": "File too large",
  "ApiErrorCode.211104013": "Invalid file extension",
  "ApiErrorCode.211104014":
    "The business party has not configured check rules for file verification",
  "ApiErrorCode.211104015": "This file category cannot be checked",
  "ApiErrorCode.211104016": "Playback duration exceeds limit",
  "ApiErrorCode.211104017": "File FPS too high",
  "ApiErrorCode.211104018": "File bitrate too high",
  "ApiErrorCode.211104019": "Invalid file header",
  "ApiErrorCode.211104020": "Uploading files too frequently",
  "ApiErrorCode.212101101": "Customer data does not exist",
  "ApiErrorCode.212101102": "Store data was not found",
  "ApiErrorCode.212101103": "Failed to remove blocked customer",
  "ApiErrorCode.212101104": "Imported file is invalid",
  "ApiErrorCode.212101105": "Import record not found",
  "ApiErrorCode.212101106": "Import not completed",
  "ApiErrorCode.212101107": "File that failed to be imported unable to found",
  "ApiErrorCode.212101108": "File that failed to be imported has expired",
  "ApiErrorCode.213101001": "Custom field name is duplicated",
  "ApiErrorCode.213101002": "Failed to create custom field",
  "ApiErrorCode.213101003": "Custom field does not exist",
  "ApiErrorCode.213101004": "Exceeded custom field limit",
  "ApiErrorCode.213101005": "Failed to update custom field",
  "ApiErrorCode.213101006": "Custom field type does not meet requirements",
  "ApiErrorCode.213101007":
    "Custom field business type does not meet requirements",
  "ApiErrorCode.213102001": "No permission to create associated custom fields",
  "ApiErrorCode.213102002":
    "Custom field value does not meet format requirements",
  "ApiErrorCode.213102003": "No permission to operate",
  "ApiErrorCode.214101001": "Failed to export",
  "ApiErrorCode.214101002":
    "The maximum number of exports has been reached for today. Please try again tomorrow.",
  "ApiErrorCode.214101003":
    "Frequent operations, please try again in 5 minutes",
  "ApiErrorCode.214101004": "Repeated generation failed",
  "ApiErrorCode.214101005": "The export record was not found",
  "ApiErrorCode.214101006":
    "Failed to get the download link. Please try again later.",
  "ApiErrorCode.214101007": "Alibaba cloud API request error",
  "ApiErrorCode.214101008": "File being generated. Please try again later.",
  "ApiErrorCode.214101009":
    "The data you are trying to export exceeds the maximum time range",
  "ApiErrorCode.214101010": "Invalid segment ID",
  "ApiErrorCode.214101011":
    "Check whether the Segment is in the Active state and try again.",
  "ApiErrorCode.214101101":
    "Failed to create promotion, please try again later.",
  "ApiErrorCode.214101102":
    "Failed to update promotion, please try again later.",
  "ApiErrorCode.214101104":
    "Unable to start promotion due to promotion status or promotion time configuration.",
  "ApiErrorCode.214101105": "Unable to end promotion due to promotion status",
  "ApiErrorCode.214101106": "Unable to edit promotion due to promotion status",
  "ApiErrorCode.214101107":
    "Each store can only have 5 store-wide gift promotions. Please select again.",
  "ApiErrorCode.214101108": "Only draft/not-started promotions can be deleted",
  "ApiErrorCode.214101109": "Threshold should be incremental",
  "ApiErrorCode.214101110": "Only ongoing promotions can be paused",
  "ApiErrorCode.214101111": "Selected gift is not activated",
  "ApiErrorCode.214101112": "Selected gift is being used for other promotions",
  "ApiErrorCode.214101113": "Selected product has been deleted",
  "ApiErrorCode.214101114":
    "Selected product is being used for other promotions",
  "ApiErrorCode.214101115": "Promotion ID doesn't exist",
  "ApiErrorCode.214101118":
    "One X yuan off or X% off promotion applicable to all products already exists for the same period. Please select again",
  "ApiErrorCode.214101119":
    "There is a single activity discount of 0 yuan or negative number, the order cannot be placed",
  "ApiErrorCode.214102108": "Failed to delete promotion",
  "ApiErrorCode.300102000":
    "Sorry, server error, please contact the administrator",
  "ApiErrorCode.300102001": "SKU is invalid, please place a new order",
  "ApiErrorCode.300102002":
    "Payment failed, please try another method or try again later",
  "ApiErrorCode.300102003": "Order has been paid, please do not submit again",
  "ApiErrorCode.300102011": "Parameter exception",
  "ApiErrorCode.300102013": "Parameter exception",
  "ApiErrorCode.300102021": "Operation failed, please try again later",
  "ApiErrorCode.300102022": "User does not exist, please check",
  "ApiErrorCode.600101104":
    "The URL you entered is not correct. Please ensure that the URL begins with https:// and that the URL is not an IP domain.",
  "ApiErrorCode.600101106": "KMS decryption error.",
  "ApiErrorCode.2009001005": "Cookies have been forcefully expired",
  "ApiErrorCode.2009004001":
    "There are no available 'Assets' in this organization",
  "ApiErrorCode.2009004002":
    "Social e-commerce is disabled for this organization. Please contact your administrator to complete your purchase or renewal.",
  "ApiErrorCode.2009004003":
    "Social marketing is disabled for this organization. Please contact your administrator to complete your purchase or renewal.",
  "ApiErrorCode.2009004004":
    "CRM integration is disabled for this organization. Please contact your administrator to complete your purchase or renewal.",
  "ApiErrorCode.000": "Sorry, server error, please contact an admin",
  "ApiErrorCode.001": "No permission, please contact an admin",
  "ApiErrorCode.002": "Please check if the input is valid",
  "ApiErrorCode.003": "Invalid parameter format",
  "ApiErrorCode.004": "Please contact an admin",
  "ApiErrorCode.006": "Please contact an admin",
  "ApiErrorCode.009": "Request method not supported",
  "ApiErrorCode.010": "Invalid parameter",
  "ApiErrorCode.011": "Record not found",
  "@business.custom-field.update-value.empty":
    "There are currently no custom fields that can be updated",
  "@business.custom-field.update-value.title": "Update Custom Fields Value",
  "@business.custom-field.update.writeable.modal.notification":
    "You can only modify the values of custom fields with BusinessOpenAPI write capability enabled",
  "@business.custom=field.update.writeable.is.empty":
    "There are currently no custom fields that enable BusinessOpenAPI write capability",
  "AfterSale.Detail.after-sale-detail": "Aftersales Details",
  "AfterSale.Detail.after-sale-info": "Aftersales Information",
  "AfterSale.Detail.after-sale-info.created_at": "Created Time",
  "AfterSale.Detail.after-sale-info.description": "Explanation",
  "AfterSale.Detail.after-sale-info.estimated_refund_amount":
    "Refundable Amount",
  "AfterSale.Detail.after-sale-info.evidence_images": "Evidence",
  "AfterSale.Detail.after-sale-info.reason": "Reason",
  "AfterSale.Detail.after-sale-product": "Aftersales Products",
  "AfterSale.Detail.after-sale-product.is_giveaway": "Gift",
  "AfterSale.Detail.after-sale-product.quantity": "Quantity",
  "AfterSale.Detail.after-sale-status": "Status",
  "AfterSale.Detail.custom-field": "Custom Fields",
  "AfterSale.Detail.delivery-info": "Return Information",
  "AfterSale.Detail.delivery-info.carrier_code": "Courier Code",
  "AfterSale.Detail.delivery-info.carrier_company": "Courier Name",
  "AfterSale.Detail.delivery-info.contact_phone": "Contact Number",
  "AfterSale.Detail.delivery-info.tracking_number": "Tracking Number",
  "AfterSale.Detail.pageHeader.after_sales_id": "Aftersales ID",
  "AfterSale.Detail.pageHeader.channel_name": "Channel",
  "AfterSale.Detail.pageHeader.order_id": "Order ID",
  "AfterSale.Detail.pageHeader.storefront_name": "Storefront",
  "AfterSale.Detail.pageHeader.type": "Type",
  "AfterSale.Detail.process-flows": "Status History",
  "AfterSale.Detail.process-flows.status-remark": "Remark",
  "AfterSale.Detail.status-records": "History",
  "AfterSale.Detail.title": "Aftersales Details",
  "AfterSale.List.title": "Aftersales List",
  "AfterSale.filter.aftersales_id": "Aftersales ID",
  "AfterSale.filter.aftersales_id.placeholder": "Please enter aftersales ID",
  "AfterSale.filter.apply_end_time": "End Time",
  "AfterSale.filter.apply_start_time": "Start Time",
  "AfterSale.filter.channel": "Channel",
  "AfterSale.filter.created_at": "Created Time",
  "AfterSale.filter.order_id": "Order ID",
  "AfterSale.filter.order_id.placeholder": "Please enter order ID",
  "AfterSale.filter.status": "Status",
  "AfterSale.filter.storefront": "Storefront",
  "AfterSale.filter.type": "Type",
  "AfterSale.status.1": "Refund Request",
  "AfterSale.status.10": "Return Parcel Received",
  "AfterSale.status.11": "Return Failed",
  "AfterSale.status.12": "Closed",
  "AfterSale.status.2": "Refund Rejected",
  "AfterSale.status.3": "Refunding",
  "AfterSale.status.4": "Refund Successful",
  "AfterSale.status.5": "Refund Failed",
  "AfterSale.status.6": "Return Request",
  "AfterSale.status.7": "Return Rejected",
  "AfterSale.status.8": "Return Approved",
  "AfterSale.status.9": "Return Dispatching",
  "AfterSale.table.after_sales_id": "Aftersales ID",
  "AfterSale.table.channel": "Channel",
  "AfterSale.table.created_at": "Requested at",
  "AfterSale.table.estimated_refund_amount": "Refundable Amount",
  "AfterSale.table.order_id": "Order ID",
  "AfterSale.table.status": "Status",
  "AfterSale.table.storefront": "Storefront",
  "AfterSale.table.type": "Type",
  "AfterSale.title": "Aftersales",
  "AfterSale.type.1": "Unshipped Refund",
  "AfterSale.type.2": "Shipped Refund Only",
  "AfterSale.type.3": "Return and Refund",
  "Auth.BindAuthenticator.card.info.row1":
    "For your account security, Salesforce Social Commerce & Messaging has enabled multi-factor authentication for you. Each time you log in, after entering your account password, you will also need to enter your security code using the bundled Authenticator APP to ensure that the person logging in is you.",
  "Auth.BindAuthenticator.card.info.row2":
    "You have not yet bound your Authenticator, please complete the following steps. Refer to {link}",
  "Auth.BindAuthenticator.card.info.bound.row1":
    "For your account security, Salesforce Social Commerce & Messaging has enabled multi-factor authentication for you. Each time you log in, after entering your account password, you will also need to enter your security code using the bundled Authenticator APP to ensure that the person logging in is you.",
  "Auth.BindAuthenticator.card.info.bound.row2":
    "You have not yet bound your Authenticator, please complete the following steps. Refer to {link}",
  "Auth.BindAuthenticator.card.info.link": "User Guide for more information",
  "Auth.BindAuthenticator.card.step.1.info":
    "After scanning successfully, please complete initial verification to complete linking.",
  "Auth.BindAuthenticator.card.step.1.label":
    "Please use the authenticator App to scan the QR code",
  "Auth.BindAuthenticator.card.step.1.title": "Step 1",
  "Auth.BindAuthenticator.card.step.2.form.label":
    "Authenticator Security Code",
  "Auth.BindAuthenticator.card.step.2.label":
    "Please enter the security code shown in the authenticator.",
  "Auth.BindAuthenticator.card.step.2.title": "Step 2",
  "Auth.BindAuthenticator.card.tip.1":
    "Download and install the authenticator application in app store of your Android or IOS device. We highly recommend you to use Salesforce Authenticator. Google Authenticator, Okta Verify and other vendors' authenticator application are also supported.",
  "Auth.BindAuthenticator.card.tip.2":
    'Please use the phone number "{phone}" bound by the account "{email}" for SMS verification.',
  "Auth.BindAuthenticator.card.title": "Link Authenticator",
  "Auth.BindAuthenticator.form.hint.placeholder":
    "Please enter the SMS verification code.",
  "Auth.BindAuthenticator.sms.hint.placeholder": "Input Verification Code",
  "Auth.InputAuthenticator.code.label":
    "Please enter the security code shown in the authenticator.",
  "Auth.InputAuthenticator.code.verify.error":
    "MFA security code verification fail",
  "Auth.InputAuthenticator.form.hint.placeholder": "Please enter security code",
  "Auth.InputAuthenticator.reset.link": "Rebind Authenticator",
  "Auth.InputAuthenticator.title":
    "Please enter the security code shown in the authenticator.",
  "Auth.Login.side.head.info": "Operated by Alibaba Cloud",
  "Auth.Login.side.head.title": "Connected Experiences Gateway",
  "Auth.Login.side.informationSet": [
    "Integrate with critical local platforms",
    "Unify data across channels to create a 360 degree view of your customer",
    "Leverage the power of Alibaba Cloud to scale easily, securely, and flexibly",
  ],
  "Auth.Login.tip":
    "Connected Experiences Gateway is the world's leading platform, providing faster and safer solutions for top brands in various industries",
  "Auth.Login.title": "Login",
  "Auth.SelectOrg.account.invalid.error":
    "Your account is invalid, please contact admin!",
  "Auth.SelectOrg.announcement.modal.label.publish-time": "Publish Time:",
  "Auth.SelectOrg.announcement.modal.label.publisher": "Publisher:",
  "Auth.SelectOrg.announcement.modal.title": "Announcement",
  "Auth.SelectOrg.asset.no-permission":
    "There are no available Assets in this organization, please contact the administrator",
  "Auth.SelectOrg.org.selection.error": "Select Organization",
  "Auth.SelectOrg.org.selection.finish.label": "Visit System Homepage",
  "Auth.SelectOrg.org.selection.label": "Organization",
  "Auth.SelectOrg.org.selection.placeholder": "Select Organization",
  "Auth.SelectOrg.org.selection.title": "Select Organization",
  "Auth.SelectOrganization.title": "Select Organization",
  "Auth.TenantActivation.edit.form.confirmPassword": "Confirm Password",
  "Auth.TenantActivation.edit.form.confirmPassword.placeholder":
    "Please confirm password",
  "Auth.TenantActivation.edit.form.confirmPassword.validateError":
    "Please enter the correct password!",
  "Auth.TenantActivation.edit.form.password": "New Password",
  "Auth.TenantActivation.edit.form.password.placeholder":
    "Please set your new password",
  "Auth.TenantActivation.edit.form.password.validateError":
    "Please enter a password that contains at least capital letters + numbers + special characters, and the length should be at least 10 digits.",
  "Auth.TenantActivation.edit.form.submit": "Log in",
  "Auth.TenantActivation.edit.header": "Password Setting",
  "Auth.TenantActivation.edit.phone.code.label": "Send Verification Code",
  "Auth.TenantActivation.edit.phone.code.send.success":
    "Verification code has been sent, please check!",
  "Auth.TenantActivation.edit.phone.form.code": "Verification code",
  "Auth.TenantActivation.edit.phone.form.phone": "Phone",
  "Auth.TenantActivation.edit.phone.form.phone.valid":
    "The format of phone number is wrong.",
  "Auth.TenantActivation.edit.phone.tip":
    "For your account security, Salesforce Social Commerce & Messaging requires your phone number for multi-factor authentication.",
  "Auth.TenantActivation.edit.phone.title": "Set Mobile Phone Number",
  "Auth.TenantActivation.edit.ps.tip.1":
    "Password contains at least uppercase letter, number, special symbol.",
  "Auth.TenantActivation.edit.ps.tip.2":
    "The password length should be at least 10 digits.",
  "Auth.TenantActivation.edit.ps.title": "Set Login Password",
  "Auth.TenantActivation.expire.action": "Back",
  "Auth.TenantActivation.expire.content.regard": "Hello",
  "Auth.TenantActivation.expire.content.row_1":
    "Your activation link is invalid",
  "Auth.TenantActivation.expire.content.row_2":
    "please contact your administrator",
  "Auth.TenantActivation.expire.header": "Your activation link is invalid!",
  "Auth.TenantActivation.title": "Password Setting",
  "Auth.TenantJoin.edit.content.row_1":
    'Are you sure to join "{orgName}" organization?',
  "Auth.TenantJoin.edit.content.row_2":
    "After successfully logging in, you will be able to directly access the organization's information.",
  "Auth.TenantJoin.edit.header": "Join a new organization",
  "Auth.TenantJoin.success.action": "Log in",
  "Auth.TenantJoin.success.content":
    'You have successfully joined the "{orgName}" organization',
  "Auth.TenantJoin.title": "Join a new organization",
  "Auth.title": "Salesforce on Alibaba Cloud",
  "Channel.CCApi.unActive": "SalesforceCloud API has  not been set up",
  "Channel.Corp.title": "Offline Channel",
  "Channel.CorpList.header.create": "Create Offline Store",
  "Channel.CorpList.storeCard.ali.tips_1":
    "Please complete Alipay Pay-in-Person contract signing",
  "Channel.CorpList.storeCard.ali.tips_2": "Alipay scan to authorize",
  "Channel.CorpList.storeCard.ali.tips_2.event.auth": "Reauthorization",
  "Channel.CorpList.storeCard.ali.tips_2.event.unAuth": "Scan to Authorize",
  "Channel.CorpList.storeCard.ali.tips_2.status.auth": "Authorized",
  "Channel.CorpList.storeCard.ali.tips_2.status.unAuth": "Unauthorized",
  "Channel.CorpList.storeCard.ali.tips_3.event.signed":
    "Alipay Pay-in-Person Pay has been set up",
  "Channel.CorpList.storeCard.ali.tips_3.event.unSign": "Verify Status",
  "Channel.CorpList.storeCard.bottom.edit-name": "Edit Name",
  "Channel.CorpList.storeCard.bottom.form.edit-name": "Store Name",
  "Channel.CorpList.storeCard.step1": "Step 1",
  "Channel.CorpList.storeCard.step2": "Step 2",
  "Channel.CorpList.storeCard.step3": "Step 3",
  "Channel.CorpList.storeCard.wx.tips_1": "Set up WeChat Pay",
  "Channel.CorpList.storeCard.wx.tips_2": "WeChat Pay binding Website",
  "Channel.CorpList.storeCard.wx.tips_3": "Signing Status",
  "Channel.CorpList.storeCard.wx.tips_3.status.signed": "Signed",
  "Channel.CorpList.storeCard.wx.tips_3.status.unSign": "Unsigned",
  "Channel.CorpList.title": "Create Offline Store",
  "Channel.WeChatMiniProgramList.actions.button": "Register New",
  "Channel.WeChatMiniProgramList.cardItem.api.completed":
    "Salesforce Social Commerce API has been set up",
  "Channel.WeChatMiniProgramList.cardItem.api.link": "Develop",
  "Channel.WeChatMiniProgramList.cardItem.bottomNode.close":
    "Disable Storefront",
  "Channel.WeChatMiniProgramList.cardItem.bottomNode.open": "Enable Storefront",
  "Channel.WeChatMiniProgramList.cardItem.rightNode.status.disabled":
    "Disabled",
  "Channel.WeChatMiniProgramList.cardItem.rightNode.status.enabled": "Enabled",
  "Channel.WeChatMiniProgramList.cardItem.rightNode.text": "Register Date",
  "Channel.WeChatMiniProgramList.cardItem.wx.add": "Bind",
  "Channel.WeChatMiniProgramList.cardItem.wx.completed": "WeChat Pay linked",
  "Channel.WeChatMiniProgramList.cardItem.wx.open.date": "Set up time",
  "Channel.WeChatMiniProgramList.cardItem.wx.openWay":
    "How to Set Up WeChat Pay?",
  "Channel.WeChatMiniProgramList.cardItem.wx.re-bind": "Update",
  "Channel.WeChatMiniProgramList.cardItem.wx.uncompleted":
    "WeChat Pay not linked",
  "Channel.WeChatMiniProgramList.pageHeader.info": "{num} items",
  "Channel.WeChatMiniProgramList.title": "WeChat Mini Programs",
  "Channel.WeChatMiniProgramPost.ChinaCloudApi.codeLink":
    "Download sample Mini Program code.zip",
  "Channel.WeChatMiniProgramPost.ChinaCloudApi.qrcodeText": "Scan to try",
  "Channel.WeChatMiniProgramPost.ChinaCloudApi.row_1.intro":
    "1. If you already have an existing Mini Program, you can directly check {link} to connect with Salesforce Social Commerce APIs and finish the linking process.",
  "Channel.WeChatMiniProgramPost.ChinaCloudApi.row_1.intro.link":
    '"How to Connect to Salesforce Social Commerce APIs"',
  "Channel.WeChatMiniProgramPost.ChinaCloudApi.row_2.intro":
    '2. You can use the sample Mini Program front-end code to jump start your project. Please click "preview" to experience our sample Mini Program.',
  "Channel.WeChatMiniProgramPost.ChinaCloudApi.title":
    "Connect to Salesforce Social Commerce API",
  "Channel.WeChatMiniProgramPost.MiniProgramAuth.error.description":
    "This Mini Program has already been linked.",
  "Channel.WeChatMiniProgramPost.MiniProgramAuth.error.retry": "Reauthorize",
  "Channel.WeChatMiniProgramPost.MiniProgramAuth.error.title":
    "Authorization Failed",
  "Channel.WeChatMiniProgramPost.MiniProgramAuth.success.description":
    "Obtained App ID, Access Token",
  "Channel.WeChatMiniProgramPost.MiniProgramAuth.success.title":
    "Successfully authorized, new Storefront has been set up.",
  "Channel.WeChatMiniProgramPost.MiniProgramAuth.title":
    "Mini Program Authorization",
  "Channel.WeChatMiniProgramPost.MiniProgramPay.success.description":
    "WeChat Pay has been set up for this Mini Program , obtained Merchant ID, Secret Key.",
  "Channel.WeChatMiniProgramPost.MiniProgramPay.success.title":
    "WeChat Pay has been linked",
  "Channel.WeChatMiniProgramPost.MiniProgramPay.title": "Link WeChat Pay",
  "Channel.WeChatMiniProgramPost.MiniProgramPay.warning.bottomTips":
    "You can skip this step and go to the next step. The information can be submitted again in 【Channel – Website】",
  "Channel.WeChatMiniProgramPost.MiniProgramPay.warning.description_1":
    "Please check details here.",
  "Channel.WeChatMiniProgramPost.MiniProgramPay.warning.description_2":
    "How do I set up WeChat Pay?",
  "Channel.WeChatMiniProgramPost.MiniProgramPay.warning.submit": "Submit",
  "Channel.WeChatMiniProgramPost.MiniProgramPay.warning.title":
    "WeChat Pay not linked",
  "Channel.WeChatMiniProgramPost.completed": "Done",
  "Channel.WeChatMiniProgramPost.title":
    "Register a new WeChat Mini Program Storefront",
  "Channel.Website.alipay.active": "Alipay linked",
  "Channel.Website.alipay.bindAuth.failed":
    "Authorization failed. Please rescan the QR code and try again.",
  "Channel.Website.alipay.bindAuth.success":
    "Authorization successful. Alipay is now linked.",
  "Channel.Website.alipay.modal.scanned": "Scanned",
  "Channel.Website.alipay.unActive": "Alipay not linked",
  "Channel.Website.alipay.unActive.action": "Link",
  "Channel.Website.alipay.unActive.tip": "How to set up Alipay web payment?",
  "Channel.Website.auth.qrcode.refresh": "Rescan QR Code",
  "Channel.Website.modal.wx-login.form.label.app_id": "Web App ID",
  "Channel.Website.modal.wx-login.form.label.app_secret": "Web App Secret",
  "Channel.Website.modal.wx-login.form.submit.success": "Link successful.",
  "Channel.Website.modal.wx-login.info":
    "The following parameters are required to access the web app WeChat login. Please see {link}",
  "Channel.Website.modal.wx-login.info.link":
    '"Web App WeChat Login Developer Guide.',
  "Channel.Website.modal.wx-login.title": "Link WeChat Login",
  "Channel.Website.pay.re-auth": "Update",
  "Channel.WebsiteList.actions.wx-login": "WeChat Login",
  "Channel.WebsiteList.ali.authModal.website.info":
    "Please enable Alipay before scanning the authorization QR code. Please see the document {link}",
  "Channel.WebsiteList.ali.authModal.website.link": "Alipay for Websites",
  "Channel.WebsiteList.ali.authModal.website.tip1":
    "1. Use the Alipay desktop app to log in to the web app admin account and scan the authorization QR code.",
  "Channel.WebsiteList.ali.authModal.website.tip2":
    '2. Select the web app you wish to authorize, then click "Sign and Authorize."',
  "Channel.WebsiteList.ali.authModal.website.title": "Link Alipay",
  "Channel.WebsiteList.edit": "Edit URL",
  "Channel.WebsiteList.moreUrl": "More",
  "Channel.WebsiteList.title": "Websites",
  "Channel.WebsitePost.ChinaCloudApi.codeLink": "Download sample website.zip",
  "Channel.WebsitePost.ChinaCloudApi.mark": "Preview link",
  "Channel.WebsitePost.ChinaCloudApi.qrcodeText": "Scan to try",
  "Channel.WebsitePost.ChinaCloudApi.row_1.intro_1":
    "1.If you already have a front-end storefront code, you can directly check",
  "Channel.WebsitePost.ChinaCloudApi.row_1.intro_2":
    '"How to Connect to Salesforce Social Commerce APIs"',
  "Channel.WebsitePost.ChinaCloudApi.row_1.intro_3":
    "to connect your Storefront to the Social Commerce Storefront API.",
  "Channel.WebsitePost.ChinaCloudApi.row_2.intro":
    "2.You can also use the sample website storefront code provided by Salesforce Social Commerce. Please click Preview to experience our sample website.",
  "Channel.WebsitePost.actions.button": "Register New",
  "Channel.WebsitePost.steps.bindWebSite": "Link Website",
  "Channel.WebsitePost.steps.bindWebSite.bindFailed": "Linking failed",
  "Channel.WebsitePost.steps.bindWebSite.bindFailed.bindAlready":
    "This website has already been linked",
  "Channel.WebsitePost.steps.bindWebSite.bindFailed.reBind": "Re-authorize",
  "Channel.WebsitePost.steps.bindWebSite.bindSuccess":
    "Linked successfully, new Storefront has been set up",
  "Channel.WebsitePost.steps.bindWebSite.form.hostName": "URL",
  "Channel.WebsitePost.steps.bindWebSite.form.hostName.addMore":
    "+ Add more URLs",
  "Channel.WebsitePost.steps.bindWebSite.form.hostName.placeholder":
    "Please enter the URL that you wish to link.",
  "Channel.WebsitePost.steps.bindWebSite.form.hostName.validate":
    "Please do not enter the same URL",
  "Channel.WebsitePost.steps.bindWebSite.form.siteName": "Website Name",
  "Channel.WebsitePost.steps.bindWebSite.form.siteName.placeholder":
    "Please enter the name of the website",
  "Channel.WebsitePost.steps.bindWebSite.form.siteName.validate":
    "Please enter a complete and valid URL",
  "Channel.WebsitePost.steps.bindWebSite.form.submit.tips_1":
    "1. Please enter a complete and valid URL.",
  "Channel.WebsitePost.steps.bindWebSite.form.submit.tips_2":
    "2. The currently linked URL cannot be relinked.",
  "Channel.WebsitePost.steps.openPay": "Set up payment method for your website",
  "Channel.WebsitePost.steps.openPay.info":
    "You can link the following payment methods",
  "Channel.WebsitePost.steps.openPay.info.tip":
    "You can skip this step and go to the next step. The information can be submitted again in [Channel - Website]",
  "Channel.WebsitePost.title": "Register new website Storefront",
  "Channel.action.preview": "Preview",
  "Channel.components.MerchantPostModal.fail":
    "API verification failed. Please enter the correct WeChat merchant information for this application.",
  "Channel.components.MerchantPostModal.miniapp.heading": "Link WeChat Pay",
  "Channel.components.MerchantPostModal.miniapp.tips":
    "If you have enabled WeChat Pay, please provide the following parameters. If you have not enabled WeChat Pay, please see {link}",
  "Channel.components.MerchantPostModal.miniapp.tips.link":
    "Set up WeChat Pay for Mini Program",
  "Channel.components.MerchantPostModal.submit": "Submit",
  "Channel.components.MerchantPostModal.success":
    "API verification passed, WeChat web payment has been set up.",
  "Channel.components.MerchantPostModal.website.heading": "Link WeChat Pay",
  "Channel.components.MerchantPostModal.website.tips":
    "Please set up WeChat Pay to retrieve the parameters below. Refer to {link}",
  "Channel.components.MerchantPostModal.website.tips.link":
    "Adding WeChat Pay to Your Website",
  "Channel.components.StoreStatusModal.activateContent":
    "Enabling the storefront will allow it to continue to access the Salesforce Social Commerce API and resume normal use.",
  "Channel.components.StoreStatusModal.activateHeading": "Enable Storefront",
  "Channel.components.StoreStatusModal.inactivateContent":
    "If you disable the Storefront, its ID will no longer be able to access the Salesforce Social Commerce API. This will not affect existing data, but it will affect the normal use of the storefront app. Please proceed with caution.",
  "Channel.components.StoreStatusModal.inactivateHeading": "Disable Storefront",
  "Channel.title": "Channels",
  "Channel.website.wxpay.active": "WeChat Pay linked",
  "Channel.website.wxpay.unActive": "WeChat Pay not linked",
  "Channel.website.unionPay.unActive": "Unbound UnionPay",
  "Channel.website.unionPay.active": "UnionPay has been bound",
  "Channel.website.unionPay.authModal.help.info":
    "Binding your UnionPay account requires you to provide the following information. {link}",
  "Channel.website.unionPay.authModal.help.link":
    "Please refer to the official documents of UnionPay to get more information.",
  "Channel.website.unionPay.authModal.bindForm.merchant": "Merchant ID",
  "Channel.website.unionPay.authModal.bindForm.merchantPwd":
    "Merchant Private Key Official Password",
  "Channel.website.unionPay.authModal.bindForm.credentials":
    "Please provide the merchant private key certificate/intermediate certificate and Root certificate of the UnionPay account. Your certificate will be encrypted and stored and only used for the payment of the store",
  "Channel.website.unionPay.authModal.title": "Bind UnionPay",
  "Channel.website.unionPay.authModal.bindForm.privateCert":
    "Please upload the merchant private key certificate (.pfx)",
  "Channel.website.unionPay.authModal.bindForm.rootCer":
    "Please upload root certificate (.cer)",
  "Channel.website.unionPay.authModal.bindForm.middleCer":
    "Please upload intermediate certificate (.cert)",
  "Channel.website.unionPay.authModal.bindForm.merchant.placeholder":
    "The merchant id must be no more than 50 characters",
  "Channel.website.unionPay.authModal.bindForm.merchantPwd.placeholder":
    "The official password of the merchant's private key is 6 pure digits",
  "Channel.website.unionPay.authModal.bindForm.privateCert.change":
    "Replacement of merchant private key certificate (.pfx)",
  "Channel.website.unionPay.authModal.bindForm.middleCer.change":
    "Replace intermediate certificate (.cer)",
  "Channel.website.unionPay.authModal.bindForm.rootCer.change":
    "Replace the root Certificate (.cer)",
  "Channel.website.unionPay.authModal.re-bind.title": "Rebind UnionPay Payment",
  "Channel.customerList.title": "Please select the Customer List of the store",
  "Channel.customerList.tips":
    "Please note that the Customer List cannot be edited after being selected. For more information, please refer to {link}",
  "Channel.customerList.tips.link": "user guide",
  "Channel.customerList.useGroupId.enable.title":
    "Exiting Customer List: share customer account with other stores",
  "Channel.customerList.useGroupId.enable.tips":
    "Select an existing Customer List, which will share the same user system as the selected store group. Users registered in any store can use the same account and password to log in to other stores in the shared user system and share user behavior and order records.",
  "Channel.customerList.storefrontGroup.validateError":
    "Please select the Customer List ID",
  "Channel.customerList.storefrontGroup.store":
    "Stores that share a customer system with this store",
  "Channel.customerList.storefrontGroup.store.website": "Website:",
  "Channel.customerList.storefrontGroup.store.wechat-mp":
    "WeChat Mini Program:",
  "Channel.customerList.useGroupId.disable.title":
    "New Customer List: doesn’t share the customer account with the existing stores",
  "Channel.customerList.useGroupId.disable.tips":
    "Create a new Customer List. After the store is successfully created, visitors need to start from registration. The store will not be able to share customer data and order records with existing stores.",
  "Channel.steps.selectCustomerList": "Select the Customer List of the store",
  "Channel.WeChatMiniProgramPost.MiniProgramAuth.form.title":
    "Select the authorized mini program",
  "Channel.WeChatMiniProgramPost.MiniProgramAuth.form.tips":
    "If the desired mini program is not available, please go to {link} to authorize the WeChat mini program",
  "Channel.WeChatMiniProgramPost.MiniProgramAuth.form.tips.link":
    "[Setting - Social Accounts]",
  "Channel.WeChatMiniProgramPost.MiniProgramAuth.form.wechat-mp.label":
    "WeChat Mini Program",
  "Channel.customerListModal.title":
    "Stores that share the customer list with this store",
  "Channel.customerListModal.tips":
    "Stores that share the customer list with this store",
  "Channel.customerListModal.trigger":
    "View stores that share the customer list with",
  "CustomerManagement.CustomerDetail.title": "Customer Information",
  "CustomerManagement.account-info": "Account Information",
  "CustomerManagement.activity.AddToCart": "Product added to cart",
  "CustomerManagement.activity.AfterSales": "Request customer service",
  "CustomerManagement.activity.BeginPay": "Initial Payment",
  "CustomerManagement.activity.CancelOrderManual": "Order canceled manually",
  "CustomerManagement.activity.CancelOrderTimeout":
    "Order has been cancelled. (Order wasn't paid within time）",
  "CustomerManagement.activity.CancelPay": "Cancel Payment",
  "CustomerManagement.activity.CollectProduct": "Add a product to Favorites",
  "CustomerManagement.activity.CreateOrder": "Order placed",
  "CustomerManagement.activity.EnterProductPage":
    "Visited product details page",
  "CustomerManagement.activity.PaySuccess": "Payment successful",
  "CustomerManagement.activity.ReceiveGoods": "Confirm receipt",
  "CustomerManagement.activity.UserRegistry": "Customer registration",
  "CustomerManagement.activity.subscribeBackInStore":
    "Subscribe back in stock notification",
  "CustomerManagement.activity.unsubscribeBackInStore":
    "Unsubscribe back in stock notification",
  "CustomerManagement.address-book-list": "Shipping Addresses",
  "CustomerManagement.aftersales-records": "Aftersales Records",
  "CustomerManagement.associated-accounts": "Linked Accounts",
  "CustomerManagement.associated-accounts.rule-one":
    "1. WeChat users from different Storefronts are automatically associated based on Union ID.",
  "CustomerManagement.associated-accounts.rule-title": "Rule Description",
  "CustomerManagement.associated-accounts.rule.content":
    "If a customer has multiple accounts in the same Customer List due to different registration parameters, we will query the user records of the same Customer List through their phone number/email/UnionID and display them in the associated account.",
  "CustomerManagement.associated-accounts.rule-two":
    "2. Website users from different Storefronts are automatically associated based on phone number.",
  "CustomerManagement.base-info": "Basic Information",
  "CustomerManagement.base-info.channel-name": "Channel Neme",
  "CustomerManagement.base-info.register-channel-name": "Register Channel",
  "CustomerManagement.base-info.register-storefront-name":
    "Register Storefront",
  "CustomerManagement.base-info.login-identifier": "Identify Account",
  "CustomerManagement.base-info.city": "City",
  "CustomerManagement.base-info.country": "Country",
  "CustomerManagement.base-info.district": "District/County",
  "CustomerManagement.base-info.email": "Email",
  "CustomerManagement.base-info.phone": "Phone",
  "CustomerManagement.base-info.gender": "Gender",
  "CustomerManagement.base-info.gender.female": "Female",
  "CustomerManagement.base-info.gender.male": "Male",
  "CustomerManagement.base-info.gender.unknown": "Unknown",
  "CustomerManagement.base-info.language": "Language",
  "CustomerManagement.base-info.province": "State/Province",
  "CustomerManagement.base-info.register-time": "Registration Date",
  "CustomerManagement.base-info.source": "Data Source",
  "CustomerManagement.base-info.source.1": "Created by User",
  "CustomerManagement.base-info.source.2": "Created by API",
  "CustomerManagement.base-info.storefront-name": "Storefront",
  "CustomerManagement.behavior-records": "Customer Activity Log",
  "CustomerManagement.behavior-records.behavior-type": "Event Filter",
  "CustomerManagement.behavior-records.record-end-time": "To",
  "CustomerManagement.behavior-records.record-start-time": "From",
  "CustomerManagement.block-list": "Blocklist",
  "CustomerManagement.block-list.block-list-status": "Blocklist Status",
  "CustomerManagement.block-list.block-list-status.on-block-list":
    "On Blocklist",
  "CustomerManagement.block-list.filter.end_time": "End time",
  "CustomerManagement.block-list.filter.keyword": "Please enter keyword(s)",
  "CustomerManagement.block-list.filter.start_time": "Start time",
  "CustomerManagement.block-list.import": "Import",
  "CustomerManagement.block-list.import-block-list": "Import Blocklist",
  "CustomerManagement.block-list.import-block-list.download-template":
    "Download Template",
  "CustomerManagement.block-list.import-block-list.msg":
    "Importing, please check the history import record later for detailed report",
  "CustomerManagement.block-list.import-block-list.option-0":
    "Update existing blocklist records",
  "CustomerManagement.block-list.import-block-list.option-1":
    "Skip existing blocklist records",
  "CustomerManagement.block-list.import-block-list.select-file": "Select File",
  "CustomerManagement.block-list.import-block-list.start": "Start",
  "CustomerManagement.block-list.import-block-list.tips":
    "Please upload a file that conforms to the import template format. The file should be less than 10MB",
  "CustomerManagement.block-list.import-record": "Import Blocklist",
  "CustomerManagement.block-list.import-record.table.import-result":
    "Import Results",
  "CustomerManagement.block-list.import-record.table.import-result.failure":
    "{failure_count} Items Failed",
  "CustomerManagement.block-list.import-record.table.import-result.pending":
    "Importing",
  "CustomerManagement.block-list.import-record.table.import-result.success":
    "{success_count} Items Success",
  "CustomerManagement.block-list.import-record.table.import-time":
    "Import Time",
  "CustomerManagement.block-list.import-record.table.operation": "Operation",
  "CustomerManagement.block-list.import-record.table.operation.download":
    "Download Report",
  "CustomerManagement.block-list.import-record.table.operator": "Operator",
  "CustomerManagement.block-list.import-record.title": "Import Record",
  "CustomerManagement.block-list.restrictions-on-blocklist":
    "Restrictions on blocklist",
  "CustomerManagement.block-list.restrictions-on-blocklist.login":
    "Unable to Login/Register",
  "CustomerManagement.block-list.restrictions-on-blocklist.order":
    "Allow to Login but unable to place the order",
  "CustomerManagement.block-list.table.affected-users": "Affected users",
  "CustomerManagement.block-list.table.affected-users.tooltips":
    "The number of affected users will be updated after the blocklist import progress finished, and will be updated automatically at 1:00 a.m. every day.",
  "CustomerManagement.block-list.table.description": "Description",
  "CustomerManagement.block-list.table.identifier": "Blocklist Identifier",
  "CustomerManagement.block-list.table.operation": "Operation",
  "CustomerManagement.block-list.table.remove": "Remove",
  "CustomerManagement.block-list.table.remove.tips":
    "Are you sure to remove this data from the blocklist?",
  "CustomerManagement.block-list.table.update-time": "Update Time",
  "CustomerManagement.block-list.upload-file-msg.failed": "File upload failed",
  "CustomerManagement.block-list.upload-file-msg.limit":
    "Please upload the file that meets the rule",
  "CustomerManagement.consent": "Authorization Log",
  "CustomerManagement.consent.activity.accept.agreement_title":
    "Regulations accepted",
  "CustomerManagement.consent.activity.accept.scope":
    "Scope of approved authorization:",
  "CustomerManagement.consent.activity.accept.title":
    "Customer authorization approved",
  "CustomerManagement.consent.activity.deny.agreement_title":
    "Regulations not accepted",
  "CustomerManagement.consent.activity.deny.scope":
    "Scope of declined authorization:",
  "CustomerManagement.consent.activity.deny.title":
    "Customer authorization declined",
  "CustomerManagement.consent.activity.revoke.scope":
    "Scope of canceled authorization:",
  "CustomerManagement.consent.activity.revoke.title":
    "Customer authorization canceled",
  "CustomerManagement.consent.scope.PII-Basic":
    "Customer nickname, gender, phone number, country, state/province, city, collection log, browsing log, delivery address, order information",
  "CustomerManagement.default-address": "【Default Address】",
  "CustomerManagement.filter.channel-name": "Storefront",
  "CustomerManagement.filter.channel-type": "Channel",
  "CustomerManagement.filter.end-date": "To",
  "CustomerManagement.filter.start-date": "From",
  "CustomerManagement.filter.keyword": "Please enter keyword(s)",
  "CustomerManagement.filter.keyword.placeholder":
    "You can search for Customer ID, Customer name, mobile phone or email. ID search must be entered in full",
  "CustomerManagement.order-list": "Orders",
  "CustomerManagement.receiver-address": "Shipping Address",
  "CustomerManagement.receiver-name": "Receiver Name",
  "CustomerManagement.receiver-phone": "Receiver Phone",
  "CustomerManagement.record-count": "Total {count} records",
  "CustomerManagement.table.avatar": "Profile Photo",
  "CustomerManagement.table.blocked": "Blocklist Status",
  "CustomerManagement.table.blocked.false": "Out of Blocklist",
  "CustomerManagement.table.blocked.true": "On Blocklist",
  "CustomerManagement.table.channel-name": "Channel",
  "CustomerManagement.table.id": "Customer ID",
  "CustomerManagement.table.nickname": "Customer Name",
  "CustomerManagement.table.phone": "Phone Number",
  "CustomerManagement.table.register-time": "Registration Date",
  "CustomerManagement.table.serial-number": "Serial Number",
  "CustomerManagement.table.storefront-name": "Storefront",
  "CustomerManagement.title": "Customers",
  "CustomerManagement.close-customer-account.button": "Close Customer Account",
  "CustomerManagement.close-customer-account.modal.1.title":
    "Close Customer Account",
  "CustomerManagement.close-customer-account.modal.1.content.row1":
    "Closing a customer will delete all customer identification information, including but not limited to the customer's name, account number, shipping address, and other information\nPlease verify with the customer before your cancellation operation.",
  "CustomerManagement.close-customer-account.modal.1.content.row2":
    "To continue the operation, please click Confirm.",
  "CustomerManagement.close-customer-account.modal.2.file.tips.row1":
    "1.Supports up to 3 images",
  "CustomerManagement.close-customer-account.modal.2.file.tips.row2":
    "2.The size of a single image should be not exceed 5MB.",
  "CustomerManagement.close-customer-account.modal.2.file.tips.row3":
    "3.Supported formats: bmp, jpg, jpeg, png, gif, svg, tiff.",
  "CustomerManagement.close-customer-account.modal.2.file.tips.row4":
    "4.Adding image links only supprots adding those links under whitelist domains.",
  "CustomerManagement.close-customer-account.modal.2.reason":
    "The reason for closing",
  "CustomerManagement.close-customer-account.modal.2.reason.placeholder":
    "Please input the reason",
  "CustomerManagement.close-customer-account.modal.2.evidence":
    "Upload the evidence images",
  "CustomerManagement.close-customer-account.modal.2.evidence.option.0":
    "Upload Image Files",
  "CustomerManagement.close-customer-account.modal.2.evidence.option.1":
    "Store URL directly",
  "CustomerManagement.close-customer-account.modal.2.notification.tips.valid":
    "The store that this account belongs has enabled a successful cancellation event notification. Once the cancellation is completed, a text message/email will be sent",
  "CustomerManagement.close-customer-account.modal.2.notification.tips.permision-error":
    "Insufficient permissions to query notification configuration status",
  "CustomerManagement.close-customer-account.modal.2.notification.tips.invalid":
    "The store that this account belongs has not opened a successful cancellation event notification. Once the cancellation is completed, SMS/email cannot be sent. Please go to  {link}  to Complete relevant configurations",
  "CustomerManagement.close-customer-account.modal.2.notification.tips.invalid.link":
    "Store notification",
  "CustomerManagement.social-identifier": "Social Profile",
  "CustomerManagement.social-identifier.storefront": "Social Channel",
  "CustomerManagement.social-identifier.open_id": "Open ID",
  "CustomerManagement.social-identifier.union_id": "Union ID",
  "Download.export-modal.default.info":
    "In order to provide you with better query performance and experience, we have improved the export function:",
  "Download.export-modal.default.tips": [
    "To ensure your export performance, the exported data needs to be obtained in the Download Center;",
    "In order to ensure your export performance, please maintain a time interval of at least 5 minutes between exports.",
  ],
  "Download.export-modal.default.title": "Export Report",
  "Download.export.origin.type.enum": {
    LOGIN_LOG: "Login Log Report",
    OPERATION_LOG: "Operation Log Report",
    ORDER: "Order Report",
  },
  "Download.export.status.enum": {
    FAILED: "Creation Failed",
    GENERATION: "Creating",
    SUCCESS: "Creation Complete",
  },
  "Download.list.column.header.create_time": "Report Creation Time",
  "Download.list.column.header.name": "Report Name",
  "Download.list.column.header.operation.download": "Download",
  "Download.list.column.header.operation.refresh": "Refresh",
  "Download.list.column.header.operation.regenerate": "Recreate",
  "Download.list.column.header.status": "Status",
  "Download.list.column.header.type": "Report Type",
  "Download.list.title": "Download List",
  "Download.management.info":
    "Reminder: 1. To protect data security, you can only view the report details downloaded by the current login account; 2. The report data is only kept for 24 hours and will be cleared automatically after timeout.",
  "Download.management.title": "Download Center",
  "Download.operation.frequently.tip":
    "Frequent operation, please try again later",
  "Download.operation.success.content":
    "The export operation is successful. Please go to the Download Center to view the exported data.",
  "Download.operation.success.title": "Operation Successful",
  "Download.title": "Download",
  "Global.Component.Combobox.placeholder": "Select an Option",
  "Global.Component.ConditionTable.FilterBar.title": "Filters",
  "Global.Component.DuelingPickList.selected": "Selected",
  "Global.Component.DuelingPickList.unselected": "Unselected",
  "Global.Component.Editor.Modal.images": "Image",
  "Global.Component.Editor.Modal.title": "Insert Image",
  "Global.Component.Editor.Variable.label": "Insert Variable",
  "Global.Component.Upload.maxLength.valid":
    "Upload failed. The file cannot exceed {maxSize}M. Please upload again",
  "Global.Component.Upload.operation.success": "Upload successfully",
  "Global.Component.Upload.path.file": "Upload using file",
  "Global.Component.Upload.path.link": "Upload using link",
  "Global.Component.Upload.video.transcode-failed": "Transcoding failed",
  "Global.Component.Upload.video.transcoding": "Transcoding...",
  "Global.Component.filter.create_at": "Created At",
  "Global.Component.upload.image.max-out":
    "Support to upload {MaxLength} pictures at most",
  "Global.Components.Divider.noMore": "No More",
  "Global.Components.Form.ComboboxControl.noOptionsFound": "No matches found",
  "Global.Components.Form.DefaultErrorText.maxLength":
    "Please enter no more than {maxLength} characters",
  "Global.Components.Form.DefaultErrorText.minLength":
    "Please enter at least {minLength} characters",
  "Global.Components.Form.DefaultErrorText.require":
    "This item cannot be empty",
  "Global.Components.InitialContainer.empty": "No data",
  "Global.Components.InitialContainer.error.btnName": "Retry",
  "Global.Components.InitialContainer.error.msg": "Failed to retrieve data",
  "Global.Components.Prompt.button.confirm": "Confirm",
  "Global.Components.Prompt.desc":
    "Data will not be stored if you leave, are you sure to leave?",
  "Global.Components.Prompt.prevent.delete": "Delete this record: {name}",
  "Global.Components.Prompt.title": "Warning",
  "Global.Components.StepWrapper.done.defaultFailed":
    "This step is not finished yet. Please complete it before proceeding to the next step.",
  "Global.Components.StepWrapper.done.defaultFailed.Final":
    "The current step is not complete.",
  "Global.Components.StepWrapper.footer.cancel": "Cancel",
  "Global.Components.StepWrapper.footer.next": "Next",
  "Global.Components.StepWrapper.footer.prev": "Previous",
  "Global.Components.StepWrapper.header.title": "Step {number}:",
  "Global.Components.Stepper.button.cancel": "Cancel",
  "Global.Components.Stepper.button.commit": "Save",
  "Global.Components.Stepper.button.next": "Next",
  "Global.Components.Stepper.button.prev": "Prev",
  "Global.action.copy.failed": "Copy failed",
  "Global.action.copy.success": "Copy successful",
  "Global.add": "Create",
  "Global.add-one": "Add",
  "Global.apply": "Apply",
  "Global.back": "Back",
  "Global.cancel": "Cancel",
  "Global.close": "Close",
  "Global.confirm": "Confirm",
  "Global.copy": "Copy",
  "Global.delete": "Delete",
  "Global.edit": "Edit",
  "Global.empty": "No data",
  "Global.export": "Export",
  "Global.finish": "Finish",
  "Global.header.apps.switch.no-ssm-asset":
    "Social Commerce is disabled for this Org. Please check with the administrator before proceeding to the purchase or renewal.",
  "Global.header.icons.title": {
    "download-center": "Download Center",
    "help-center": "Help Center",
    settings: "Settings",
  },
  "Global.header.settings.popover": {
    "commerce-settings": "Social Commerce",
    "messaging-settings": "Social Messaging",
    organization: "Organization",
    "storefront-notification": "Notification - SMS Configurations",
    tableau: "Tableau Server",
  },
  "Global.layout.account.settings": "Account Settings",
  "Global.layout.help-center": "Help Center",
  "Global.layout.logout": "Log Out",
  "Global.layout.logout.content": "Are you sure to exit？",
  "Global.layout.logout.title": "Log Out",
  "Global.layout.other-options": "OPTIONS",
  "Global.layout.switch-tenant": "My Organizations",
  "Global.layout.user-center": "Personal Info",
  "Global.load-more": "Load More",
  "Global.menus.extra.log-audit": "Audit",
  "Global.message.operation.create.success": "Created successfully",
  "Global.message.operation.delete.success": "Successfully deleted",
  "Global.message.operation.disable.success": "Disabled successfully",
  "Global.message.operation.enable.success": "Enabled successfully",
  "Global.message.operation.success": "Operation Successful",
  "Global.message.operation.update.success": "Updated successfully",
  "Global.miniprogram": "Mini Program",
  "Global.no-cover": "No cover",
  "Global.no-resource": "No resources",
  "Global.number_0": "0",
  "Global.number_1": "1",
  "Global.number_10": "10",
  "Global.number_2": "2",
  "Global.number_3": "3",
  "Global.number_4": "4",
  "Global.number_5": "5",
  "Global.number_6": "6",
  "Global.number_7": "7",
  "Global.number_8": "8",
  "Global.number_9": "9",
  "Global.ok": "Confirm",
  "Global.operation": "operation",
  "Global.other": "Other",
  "Global.page-not-found": "Page not found",
  "Global.page-not-found-sub_msg":
    "Please check the url and redirect to right place",
  "Global.phone-number": "Phone number",
  "Global.pii.control.hide": "Hide private information",
  "Global.pii.control.show": "Show full information",
  "Global.preview": "Preview",
  "Global.refresh": "Refresh",
  "Global.reset": "Reset",
  "Global.retry": "retry",
  "Global.save": "Save",
  "Global.search": "Filter",
  "Global.see-detail": "View details",
  "Global.settings": "Settings",
  "Global.submit": "Submit",
  "Global.system-warning": "Warning",
  "Global.total-num": "{num} items",
  "Global.unknown-resource": "Unknown URL",
  "Global.updatedAt": "Updated at",
  "Global.updatedBy": "Updated by",
  "Global.verify": "Verify",
  "Global.web": "Web",
  "Integration.demandware.basic.configuration.invalid": "Invalid configuration",
  "Integration.demandware.basic.configuration.patch.modal.confirm":
    "Verify and Save",
  "Integration.demandware.basic.configuration.patch.modal.form.api-version":
    "API Version",
  "Integration.demandware.basic.configuration.patch.modal.form.api-version.placeholder":
    "Please input the API Version with a maximum length of 10 characters",
  "Integration.demandware.basic.configuration.patch.modal.form.client-id":
    "ocApi-Client_ID",
  "Integration.demandware.basic.configuration.patch.modal.form.client-id.placeholder":
    "Please input the ocApi-Client_ID with a maximum length of 100 characters",
  "Integration.demandware.basic.configuration.patch.modal.form.client-pass":
    "ocApi-Client_Password",
  "Integration.demandware.basic.configuration.patch.modal.form.client-pass.placeholder":
    "Please input the ocApi-Client_Password with a maximum length of 100 characters",
  "Integration.demandware.basic.configuration.patch.modal.form.hostname":
    "Https Hostname",
  "Integration.demandware.basic.configuration.patch.modal.form.hostname.placeholder":
    "Please input the Https Hostname with a maximum length of 200 characters",
  "Integration.demandware.basic.configuration.patch.modal.form.site-id":
    "Storefront Site ID",
  "Integration.demandware.basic.configuration.patch.modal.form.site-id.placeholder":
    "Please input the Storefront Site ID with a maximum length of 50 characters",
  "Integration.demandware.basic.configuration.title":
    "B2C Commerce Configuration",
  "Integration.demandware.basic.configuration.valid": "Valid configuration",
  "Integration.demandware.configuration.without-keypairs.help":
    "Configure Key pairs first, please.",
  "Integration.demandware.help-info":
    "Please configure the B2C Commerce API key pairs with Write permission. For more information, see the user guide",
  "Integration.demandware.help-info.link": "user guide.",
  "Integration.demandware.sync.object.customer": "Customer",
  "Integration.demandware.sync.object.order": "Order",
  "Integration.demandware.sync.object.product": "Product",
  "Integration.demandware.sync.status.disable": "Disable",
  "Integration.demandware.sync.status.disabling": "Disabling",
  "Integration.demandware.sync.status.enable": "Enable",
  "Integration.demandware.sync.type.cycle": "Ongoing sync",
  "Integration.demandware.sync.type.once": "One-time sync",
  "Integration.demandware.task.basic-info.title": "Basic information",
  "Integration.demandware.task.create": "Create Sync Task",
  "Integration.demandware.task.create.title": "Create Sync Task",
  "Integration.demandware.task.detail.info.title": "Task information",
  "Integration.demandware.task.detail.report.table.column.operation.download":
    "Download Report",
  "Integration.demandware.task.detail.report.table.column.result": "Result",
  "Integration.demandware.task.detail.report.table.column.result.failed":
    "Item Failed",
  "Integration.demandware.task.detail.report.table.column.result.success":
    "Item Success",
  "Integration.demandware.task.detail.report.table.column.sync-time":
    "Sync Time",
  "Integration.demandware.task.detail.report.title": "Sync Task Report",
  "Integration.demandware.task.detail.title": "Task Detail",
  "Integration.demandware.task.form.basic-info.description": "Description",
  "Integration.demandware.task.form.basic-info.description.placeholder":
    "Please input the description with a maximum length of 1000 characters",
  "Integration.demandware.task.form.basic-info.name": "Task Name",
  "Integration.demandware.task.form.basic-info.name.placeholder":
    "Please input the task name with a maximum length of 200 characters",
  "Integration.demandware.task.form.basic-info.object": "Object",
  "Integration.demandware.task.form.basic-info.object.placeholder":
    "Please select object",
  "Integration.demandware.task.form.settings.catalog": "Catalog",
  "Integration.demandware.task.form.settings.catalog.placeholder":
    "Please select a catalog",
  "Integration.demandware.task.form.settings.currency": "Currency",
  "Integration.demandware.task.form.settings.currency.tooltip":
    "Social Commerce will get the default currency of Storefront Site ID.When the product is syncing, the product price will get the lowest price of the currency unit in the PriceBook defined by the product.",
  "Integration.demandware.task.form.settings.end-time": "End Time",
  "Integration.demandware.task.form.settings.end-time.placeholder":
    "Please select a end time",
  "Integration.demandware.task.form.settings.field-mapping":
    "Field Mapping(You can map Demandware fields to Social Commerce fields by click them one by one)",
  "Integration.demandware.task.form.settings.field-mapping.action.add":
    "Add to Mapping list",
  "Integration.demandware.task.form.settings.field-mapping.source.action.add":
    "Add Custom Field",
  "Integration.demandware.task.form.settings.field-mapping.source.added":
    "Added",
  "Integration.demandware.task.form.settings.field-mapping.source.empty":
    "There is no field under the current locale",
  "Integration.demandware.task.form.settings.field-mapping.source.search":
    "Please input the field name",
  "Integration.demandware.task.form.settings.field-mapping.source.title":
    "Source：B2C Commerce Field",
  "Integration.demandware.task.form.settings.field-mapping.target.title":
    "Target: Social Commerce Field",
  "Integration.demandware.task.form.settings.field-mapping.valid.required":
    "Please add a mapping relationship for the required fields of Social Commerce",
  "Integration.demandware.task.form.settings.image-root": "Image root folder",
  "Integration.demandware.task.form.settings.image-root.placeholder":
    "Please select a image root folder",
  "Integration.demandware.task.form.settings.view-type": "ViewType",
  "Integration.demandware.task.form.settings.view-type.input.placeholder":
    "Input ViewType. Max 50 characters",
  "Integration.demandware.task.form.settings.inventory-list":
    "InventoryList ID",
  "Integration.demandware.task.form.settings.inventory-list.placeholder":
    "Please select a inventoryList ID",
  "Integration.demandware.task.form.settings.locale": "Locale",
  "Integration.demandware.task.form.settings.locale.placeholder":
    "Please select a locale",
  "Integration.demandware.task.form.settings.site-id": "Storefront Site ID",
  "Integration.demandware.task.form.settings.site-id.placeholder":
    "Please select a Storefront Site ID",
  "Integration.demandware.task.form.settings.start-time": "Start Time",
  "Integration.demandware.task.form.settings.start-time.placeholder":
    "Please select a start time",
  "Integration.demandware.task.form.settings.sync-type": "Sync Type",
  "Integration.demandware.task.form.settings.sync-type.going": "Ongoing sync",
  "Integration.demandware.task.form.settings.sync-type.going.cycle":
    "Task Cycle(Mins / Cycle)",
  "Integration.demandware.task.form.settings.sync-type.going.cycle.placeholder":
    "Not more than a week (10080) minutes",
  "Integration.demandware.task.form.settings.sync-type.going.cycle.tooltip":
    "Task Cycle only supports integer min. Whenever a synchronization task ends, it will wait for a cycle interval and restart a new round of task synchronization. Until the end time.",
  "Integration.demandware.task.form.settings.sync-type.time": "One-time sync",
  "Integration.demandware.task.mapping-list.column.operation.system":
    "Generated by system",
  "Integration.demandware.task.mapping-list.column.operation.title":
    "Operation",
  "Integration.demandware.task.mapping-list.column.source.title": "Source",
  "Integration.demandware.task.mapping-list.column.target.title": "Target",
  "Integration.demandware.task.mapping-list.title": "Mapping list",
  "Integration.demandware.task.settings.title": "Task Setup",
  "Integration.demandware.task.table.column.name": "Task Name",
  "Integration.demandware.task.table.column.object": "Object",
  "Integration.demandware.task.table.column.operator": "Operator",
  "Integration.demandware.task.table.column.site-id": "Storefront Site ID",
  "Integration.demandware.task.table.column.status": "Status",
  "Integration.demandware.task.table.column.sync-type": "Sync Type",
  "Integration.demandware.task.table.column.update-at": "Updated At",
  "Integration.demandware.task.table.operation.enable.prevent":
    'To prevent data conflicts, tasks of the same object can only have one Enable. Please disable other "Product" tasks before enabling this task.',
  "Integration.demandware.task.title": "Sync Task",
  "Integration.demandware.task.update.title": "Update Sync Task",
  "Integration.demandware.title": "B2C Commerce Sync",
  "Integration.title": "Commerce Integration",
  "Notification.SMSConfig.title": "SMS Configurations",
  "Notification.addSign.confirm-btn": "Verify",
  "Notification.addSign.fail": "Submission failed",
  "Notification.addSign.inlineHelp":
    "Please paste the Alibaba Cloud-approved SMS signature here",
  "Notification.addSign.label": "Signature",
  "Notification.addSign.legal.isv.SMS_SIGNATURE_ILLEGAL":
    "SMS signature does not exist or has been added to the blacklist",
  "Notification.addSign.legal.isv.SMS_SIGN_ILLEGAL": "SMS signature disallowed",
  "Notification.addSign.placeholder": "The length should be 2–12 characters.",
  "Notification.addSign.rules.required": "Please input signature",
  "Notification.addSign.tips":
    "Please paste the Alibaba Cloud-approved SMS signature here",
  "Notification.addSign.title": "Create Signature",
  "Notification.bindEvent.email.template_content": "Message content",
  "Notification.bindEvent.email.template_name": "Subject",
  "Notification.bindEvent.email.template_name.placeholder": "Please input",
  "Notification.bindEvent.sms.preview": "Preview",
  "Notification.bindEvent.sms.sign": "Select SMS signature",
  "Notification.bindEvent.sms.sign.placeholder": "Please select SMS signature",
  "Notification.bindEvent.sms.template": "Select SMS template",
  "Notification.bindEvent.sms.template.placeholder":
    "Please select SMS template",
  "Notification.bindEvent.wx.preview": "Preview",
  "Notification.bindEvent.wx.template": "WeChat Template Message",
  "Notification.bindEvent.wx.template.placeholder":
    "Please select WeChat Template Message",
  "Notification.deleteSign.content":
    "Deleting the signature will affect the SMS notification of the corresponding event. Are you sure you want to delete?",
  "Notification.deleteSign.title": "Delete Signature",
  "Notification.deleteTemplate.content":
    "If you delete this template, the corresponding template in Ali Cloud SMS service will be deleted as well. It will affect SMS notifications. Are you sure you want to delete?",
  "Notification.deleteTemplate.title": "Delete SMS template",
  "Notification.disableEvent.content":
    "Are you sure you want to disable this notification channel?",
  "Notification.disableEvent.title": "Disable this notification channel",
  "Notification.edit-notice.title.email": "Email notification configuration",
  "Notification.edit-notice.title.sms": "SMS Notification Configuration",
  "Notification.edit-notice.title.wx":
    "WeChat Mini Program Notification Configuration",
  "Notification.edit-template.eventType": "Event Type",
  "Notification.edit-template.eventType.placeholder":
    "Please select Event Type",
  "Notification.edit-template.legal.isv.SMS_TEMPLATE_ILLEGAL":
    "SMS template does not exist or has been added to the blacklist",
  "Notification.edit-template.remark": "Application Description",
  "Notification.edit-template.remark.placeholder":
    "Please describe the detailed usage scenario and provide product links, app, official account, and company standard full name. An example usage scenario: Send user verification code during signup.",
  "Notification.edit-template.remark.rule.maxLength":
    "Application description should be no more than 100 characters",
  "Notification.edit-template.remark.rule.required":
    "Please enter application description",
  "Notification.edit-template.remark.tips":
    "The approval process is expected to take 2 hours to complete. Submissions are reviewed Monday to Sunday, from 09:00 to 23:00 Beijing time (not including national holidays).",
  "Notification.edit-template.submit": "Confirm",
  "Notification.edit-template.templateContent": "Template Content",
  "Notification.edit-template.templateContent.placeholder":
    "Variable Format${name}; example: Dear${name}, your order ${Order.ID} has been paid for successfully.",
  "Notification.edit-template.templateContent.rule.maxLength":
    "Template content should be no more than 500 characters",
  "Notification.edit-template.templateContent.rule.required":
    "Please enter template content",
  "Notification.edit-template.templateContent.tips.1":
    '1. SMS length includes "signature + template content + variable content." If the length is less than 70 characters, it will be charged as one SMS message. If it\'s more than 70, it will be defined as a long SMS, and every additional 67 characters will be charged as one SMS message.',
  "Notification.edit-template.templateContent.tips.2":
    "2. Cannot send SMS for marketing, loan, lending, lottery, or lucky draw purposes. We do NOT support SMS for financial management or real estate purposes (except for sending verification codes).",
  "Notification.edit-template.templateContent.tips.3":
    "3. Signature/template application specification: {link}",
  "Notification.edit-template.templateName": "Template Name",
  "Notification.edit-template.templateName.placeholder":
    "Please enter a name up to 30 characters long",
  "Notification.edit-template.templateName.rule.maxLength":
    "The length should be no more than 30 characters",
  "Notification.edit-template.templateName.rule.required":
    "Please enter template name",
  "Notification.edit-template.templateType": "SMS Type",
  "Notification.edit-template.templateType.0": "Verification code",
  "Notification.edit-template.templateType.1": "SMS Notification",
  "Notification.edit-template.templateType.2": "Marketing SMS",
  "Notification.edit-template.templateType.3":
    "Intl/Hong Kong/Macau/Taiwan Message",
  "Notification.edit-template.templateType.placeholder":
    "Please select SMS Type",
  "Notification.edit-template.title.add": "Create Template",
  "Notification.edit-template.title.edit": "Edit Template",
  "Notification.edit-template.title.see-detail": "View Template",
  "Notification.email-config.form.email_type": "Email sending method",
  "Notification.email-config.form.host": "SMTP server",
  "Notification.email-config.form.password": "SMTP password",
  "Notification.email-config.form.port": "SMTP port",
  "Notification.email-config.form.port.tooltip": "Please don't use port 25",
  "Notification.email-config.form.port.validate":
    "The port number should from 1 to 65535",
  "Notification.email-config.form.sender_email_addr": "Sender's email",
  "Notification.email-config.form.username": "SMTP user name",
  "Notification.email-config.form.validate_type": "SMTP verification method",
  "Notification.email-config.notification.1":
    "You need to provide the sending email information and fill in the parameters required by the SMTP protocol. For more information, please refer to the {link}",
  "Notification.email-config.notification.2": "user guide",
  "Notification.email-config.testEmail.label":
    "You can send test mail to verify whether the current SMTP configuration is effective",
  "Notification.email-config.testEmail.placeholder": "Please input",
  "Notification.email-config.testEmail.submitter": "Send test email",
  "Notification.emailConfig.title": "Email Settings",
  "Notification.enableEvent.content":
    "Are you sure you want to enable this notification channel?",
  "Notification.enableEvent.title": "Enable this notification channel",
  "Notification.event.no-sms-sign":
    "Please go to the signature management of SMS Configuration to configure.",
  "Notification.event.no-sms-sign-tmpl":
    "Please go to SMS Configuration and create a template first.",
  "Notification.event.no-sms-sign-tmpl.action": "Configure",
  "Notification.event.no-sms-sign.tip": "There is no effective SMS signature.",
  "Notification.event.no-sms-tmpl":
    "Please go to the signature management of SMS Configuration to configure.",
  "Notification.event.no-sms-tmpl.tip": "There is no effective SMS template.",
  "Notification.event.not-email-config":
    "Please go to the email configuration page and complete the following operations before you can activate email notification for this event.",
  "Notification.event.not-email-config.tip": "Configure SMTP",
  "Notification.event.not-sms-account":
    "To enable SMS for the event, go to SMS Configuration and complete the following operation.",
  "Notification.event.not-sms-account.tip1": "Configure SMS account",
  "Notification.event.not-sms-account.tip2": "Configure SMS signature",
  "Notification.event.not-sms-account.tip3": "Configure SMS template",
  "Notification.notice.details":
    "Salesforce Social Commerce enables you to customize SMS notifications for your Storefronts. You can manage notifications for each Storefront and event type on this page. Please make sure SMS account and signatures are configured before using them here.",
  "Notification.notice.title": "Notification Settings",
  "Notification.sms-account.info":
    "Salesforce Social Commerce has connected Alibaba Cloud SMS for you. Please go to Alibaba Cloud SMS account and fill in relevant parameters for binding. For more information, please refer to the {link}",
  "Notification.sms-account.info.link": "user guide",
  "Notification.sms-account.submit.button": "Submit",
  "Notification.sms-account.submit.validate.error":
    "API verification failed. Please enter the correct parameters.",
  "Notification.sms-account.submit.validate.success.prompt.content":
    "AccessKey ID: {accountID}",
  "Notification.sms-account.submit.validate.success.prompt.finish": "Complete",
  "Notification.sms-account.submit.validate.success.prompt.title":
    "Associated SMS account",
  "Notification.sms-account.submit.validate.success.toast":
    "Verification has passed and the SMS account has been connected",
  "Notification.sms-account.tip-modal.confirm": "Continue",
  "Notification.sms-account.tip-modal.content":
    "Modifying the SMS account will clear the signature and template. The configuration of your Storefront notifications will be reset. This operation cannot be undone, are you sure you want to continue?",
  "Notification.sms-account.tip-modal.title": "Edit SMS Account",
  "Notification.sms-account.unbind.text":
    "Please click Edit to link SMS account",
  "Notification.sms-accounts.tab-title": "SMS Account",
  "Notification.sms-config.ali.modal.confirm": "Submit",
  "Notification.sms-config.ali.modal.event.info":
    "Please select an event, then paste the SMS template code in the input box below. We will check whether the template matches the parameters and the SMS type provided for the event. Once verification is successful, the template can be added.",
  "Notification.sms-config.ali.modal.form.label.tmpl-code": "Template Code",
  "Notification.sms-config.ali.modal.form.label.tmpl-code.suffix": "Verify",
  "Notification.sms-config.ali.modal.form.label.tmpl-code.validate.failed":
    "Verification Failed",
  "Notification.sms-config.ali.modal.form.label.tmpl-code.validate.success":
    "Verification Successful",
  "Notification.sms-config.ali.modal.form.label.tmpl-content.action":
    "Replace Variables",
  "Notification.sms-config.ali.modal.form.label.tmpl-content.validate.failed":
    "The template contains unrecognized placeholders. Only placeholders associated with the event may be used.",
  "Notification.sms-config.ali.modal.info":
    'You can log in to the Alibaba Cloud SMS service console, select "Local Message" or "Intl/Hong Kong/Macau/Taiwan Message," and view the template code in the Template Management tab. You can also obtain the template code through Alibaba Cloud\'s AddSmsTemplate interface.',
  "Notification.sms-config.ali.variable.modal.form.label.placeholder":
    "Please select a variable",
  "Notification.sms-config.ali.variable.modal.form.label.suffix": "Replace",
  "Notification.sms-config.btn.add": "Create New Template",
  "Notification.sms-config.btn.add.eld-tmpl": "Use Previous Template",
  "Notification.sms-config.tab-title": "Signatures",
  "Notification.sms-config.table.created-at": "Created At",
  "Notification.sms-config.table.event-name": "Event Name",
  "Notification.sms-config.table.event-type": "Event Type",
  "Notification.sms-config.table.eventName.CONSUMER_CREATE_ORDER":
    "Order has been created",
  "Notification.sms-config.table.eventName.CONSUMER_ORDER_DELIVERY_SUCCESS":
    "Customer order shipped",
  "Notification.sms-config.table.eventName.CONSUMER_ORDER_PAY_SUCCESS":
    "Customer order paid successfully",
  "Notification.sms-config.table.eventName.CONSUMER_ORDER_TIMEOUT_CANCEL":
    "Order has been canceled. (Order wasn't paid on time.)",
  "Notification.sms-config.table.eventName.CUSTOM_DEACTIVED_ACCOUNT_CODE":
    "Deactived account",
  "Notification.sms-config.table.eventName.CUSTOM_FORGET_PASSWORD_CODE":
    "Forget the password",
  "Notification.sms-config.table.eventName.CUSTOM_LOGIN_CODE": "Login",
  "Notification.sms-config.table.eventName.CUSTOM_REGISTRATION_CODE":
    "Register",
  "Notification.sms-config.table.serial-number": "Serial Number",
  "Notification.sms-config.table.sign-name": "Signature Name",
  "Notification.sms-config.table.sign-status": "Approval Status",
  "Notification.sms-config.table.template-name": "Template Name",
  "Notification.sms-config.table.template-status": "Approval Status",
  "Notification.status.0": "Under Review",
  "Notification.status.1": "Approved",
  "Notification.status.10": "Externally Withdrawn",
  "Notification.status.2": "Failed",
  "Notification.status.3": "Platform Deleted",
  "Notification.status.4": "Externally Deleted",
  "Notification.store.type.title.placeholder": "Choose a storefront",
  "Notification.store.type.title.web": "Website",
  "Notification.store.type.title.wx": "WeChat Mini Program",
  "Notification.store_table.cell.operation.add_notice": "Create Notification",
  "Notification.store_table.cell.operation.disable": "Disable",
  "Notification.store_table.cell.operation.edit": "Edit",
  "Notification.store_table.cell.operation.enable": "Enable",
  "Notification.store_table.cell.operation.previewEmail": "Preview email",
  "Notification.store_table.cell.operation.previewEmail.prompt.title":
    "Preview",
  "Notification.store_table.cell.status.disable": "Disabled",
  "Notification.store_table.cell.status.enable": "Enabled",
  "Notification.store_table.cell.template.emailTitle": "Subject:",
  "Notification.store_table.cell.template.nonactivated": "Not set up yet",
  "Notification.store_table.column.event": "Event Name",
  "Notification.store_table.column.notification_channel":
    "Notification Channel",
  "Notification.store_table.column.notification_channel.SMS": "SMS",
  "Notification.store_table.column.notification_channel.email": "email",
  "Notification.store_table.column.operation": "Operation",
  "Notification.store_table.column.serial_number": "Serial Number",
  "Notification.store_table.column.status": "Status",
  "Notification.store_table.column.template": "Template",
  "Notification.store_table.eventName.CONSUMER_CREATE_ORDER":
    "Order has been created",
  "Notification.store_table.eventName.CONSUMER_ORDER_DELIVERY_SUCCESS":
    "Order shipped",
  "Notification.store_table.eventName.CONSUMER_ORDER_PAY_SUCCESS":
    "Customer order paid successfully",
  "Notification.store_table.eventName.CONSUMER_ORDER_TIMEOUT_CANCEL":
    "Order has been canceled. (Order wasn't paid on time.)",
  "Notification.store_table.eventName.CUSTOM_DEACTIVED_ACCOUNT_CODE":
    "Deactived account",
  "Notification.store_table.eventName.CUSTOM_FORGET_PASSWORD_CODE":
    "Forgot password",
  "Notification.store_table.eventName.CUSTOM_LOGIN_CODE":
    "Log in with verification code",
  "Notification.store_table.eventName.CUSTOM_REGISTRATION_CODE": "Register",
  "Notification.store_table.eventName.PRODUCT_ARRIVAL_NOTICE": "Back in stock",
  "Notification.store_table.eventName.group.NOTICE_TOPIC_COMMON": "General",
  "Notification.store_table.eventName.group.NOTICE_TOPIC_VERIFICATION_CODE":
    "Verification code",
  "Notification.store_table.eventName.group.event": "Event Type",
  "Notification.store_table.wx.cell.action.webhook": "Go to Webhook settings",
  "Notification.store_table.wx.cell.template.active":
    "Webhook is enabled. Please use it with a WeChat template",
  "Notification.store_table.wx.cell.template.in-active":
    "Webhook disabled. Please go to Webhook settings and enable webhook for this Event Type.",
  "Notification.template.btn.delete": "Delete",
  "Notification.template.btn.delete.error.isv.ERROR_TEMPLATE_NOT_DELETE":
    "Failed to Delete",
  "Notification.template.btn.detail": "Detail",
  "Notification.template.btn.edit": "Edit",
  "Notification.template.tab-title": "Templates",
  "Notification.title": "Notifications",
  "Notification.web.title": "Website Notification Configuration",
  "Notification.wx.title": "WeChat Mini Program Notification Configuration",
  "Notification.store_table.eventName.DEACTIVED_ACCOUNT_SUCCESS_NOTICE":
    "Close Customer",
  "Notification.custom-field.title": "Custom Fields",
  "Notification.custom-field.send-by-webhook.tooltip":
    'Once you enable "Send by webhook" in the custom field configuration, you can add custom fields associated with the selected events in the webhook configuration.',
  "OrderManagement.OrderDetail.title": "Order Details",
  "OrderManagement.com.update.success": "Update successful",
  "OrderManagement.delivery-info": "Shipping Info",
  "OrderManagement.delivery-info.carrier_code": "Courier Code",
  "OrderManagement.delivery-info.carrier_name": "Courier Name",
  "OrderManagement.delivery-info.shipping_status": "Shipping Status",
  "OrderManagement.delivery-info.tracking_number": "Tracking Number",
  "OrderManagement.discount-detail": "Discount Info",
  "OrderManagement.discount-detail.discount-rule": "Discount Rule",
  "OrderManagement.discount-detail.discount_amount": "Discount",
  "OrderManagement.discount-detail.participating-products":
    "Participating Products",
  "OrderManagement.discount-detail.participating-products.1": "All Products",
  "OrderManagement.discount-detail.participating-products.2":
    "Selected Products",
  "OrderManagement.discount-detail.promotion": "Promotion",
  "OrderManagement.discount-detail.promotion-name": "Promo Name",
  "OrderManagement.discount-detail.promotion-type": "Promo Type",
  "OrderManagement.discount-detail.time": "Time",
  "OrderManagement.discount-detail.time.end": "End: {time}",
  "OrderManagement.discount-detail.time.start": "Start: {time}",
  "OrderManagement.filter.channel-name": "Channel",
  "OrderManagement.filter.created-date": "Order Created",
  "OrderManagement.filter.end-time": "End Time",
  "OrderManagement.filter.header.action.export": "Export",
  "OrderManagement.filter.header.action.export.modal.footer.export.all":
    "Export All Orders",
  "OrderManagement.filter.header.action.export.modal.footer.export.part":
    "Export Current Order List",
  "OrderManagement.filter.header.action.export.modal.info":
    "In order to provide you with better query performance and experience, we have improved the export function:",
  "OrderManagement.filter.header.action.export.modal.tip.row1":
    "1. If you need to export the current order list data according to the order filtering criteria, click Export Current Order List;  If you need to export all order data, click Export All Orders;",
  "OrderManagement.filter.header.action.export.modal.tip.row2":
    "2. To ensure your export performance, the exported data needs to be obtained in the Download Center;",
  "OrderManagement.filter.header.action.export.modal.tip.row3":
    "3. In order to ensure your export performance, please maintain a time interval of at least 5 minutes between exports.",
  "OrderManagement.filter.header.action.export.modal.title": "Order export",
  "OrderManagement.filter.order-status": "Order Status",
  "OrderManagement.filter.search-name": "Filter by",
  "OrderManagement.filter.search-value": "Enter search term",
  "OrderManagement.filter.search.focusTooltip":
    "Order ID, Receiver Name, ReceiverPhone is searchable.Full information is required for ID search.",
  "OrderManagement.filter.start-time": "Start Time",
  "OrderManagement.filter.storefront-name": "Storefront",
  "OrderManagement.order-aftersales-records": "Aftersales",
  "OrderManagement.order-info": "Order Info",
  "OrderManagement.order-info.action": "Edit Order Information",
  "OrderManagement.order-info.custom-field": "Custom Field",
  "OrderManagement.order-info.custom-message": "Customer Comments",
  "OrderManagement.order-info.customer.deleted": "Customer Cancelled",
  "OrderManagement.order-info.delivery_address": "Delivery Address",
  "OrderManagement.order-info.delivery_name": "Recipient Name",
  "OrderManagement.order-info.delivery_phone": "Recipient Phone",
  "OrderManagement.order-info.discount_amount": "Total Discount",
  "OrderManagement.order-info.is_gift": "Gift Packaging",
  "OrderManagement.order-info.no": "No",
  "OrderManagement.order-info.order-title": "Order Information",
  "OrderManagement.order-info.order_actual_paid_price": "Total Amount",
  "OrderManagement.order-info.payment_actual_paid_price": "Amount Paid",
  "OrderManagement.order-info.price-title": "Price Information",
  "OrderManagement.order-info.remark": "Remarks",
  "OrderManagement.order-info.remark.add": "Add",
  "OrderManagement.order-info.remark.add-success": "Added successfully",
  "OrderManagement.order-info.remark.add-title": "Add Remarks",
  "OrderManagement.order-info.remark.placeholder": "1-500 characters",
  "OrderManagement.order-info.shipping_fee": "Shipping Fee",
  "OrderManagement.order-info.total_product_price":
    "Items Subtotal (shipping fee excluded)",
  "OrderManagement.order-info.update.addr": "Shipping Address 1",
  "OrderManagement.order-info.update.addr.detail": "Shipping Address 2",
  "OrderManagement.order-info.update.delivery_phone.valid":
    "Please enter a valid phone number",
  "OrderManagement.order-info.yes": "Yes",
  "OrderManagement.order-records": "History",
  "OrderManagement.order-status": "Order Status",
  "OrderManagement.order-status-history-records": "Receiving Info History",
  "OrderManagement.order-status-records": "Status History",
  "OrderManagement.order-status-records.created_at": "Updated at",
  "OrderManagement.order-status-records.order_status": "Order Status",
  "OrderManagement.order-status.count-down-info":
    "Order will automatically be cancelled in {time}",
  "OrderManagement.order-status.count-down-info.time":
    "{minutesDiff}minutes {secondsDiff}seconds",
  "OrderManagement.order-status.status.AUTO_CANCELLED.info":
    "Customer did not pay in time limit, order has been cancelled automatically.",
  "OrderManagement.order-status.status.CANCELLED_BY_CUSTOMER.info":
    "Customer abandoned payment, order has been cancelled.",
  "OrderManagement.order-status.status.CLOSED.info":
    "Transaction has ended, order closed.",
  "OrderManagement.order-status.status.COMPLETED.info":
    "The transaction is successful and the order is completed.",
  "OrderManagement.order-status.status.WAITING_FOR_CONFIRMED.info":
    "Product has been shipped, waiting for customer to receive.",
  "OrderManagement.order-status.status.WAITING_FOR_DELIVERY.info":
    "Order has been paid, waiting for items to be delivered by merchant.",
  "OrderManagement.order-status.status.default.info":
    "This order status is synchronized from the downstream system.",
  "OrderManagement.payment-info": "Payment Info",
  "OrderManagement.payment-info.payAt": "Payment Time",
  "OrderManagement.payment-info.paymentChannel": "Payment Method",
  "OrderManagement.payment-info.paymentChannel.ALI_WAP": "AliPay H5",
  "OrderManagement.payment-info.paymentChannel.ALI_WEB": "Ali Web Pay",
  "OrderManagement.payment-info.paymentChannel.WECHAT_MINI_APP":
    "WeChat Mini Program Pay",
  "OrderManagement.payment-info.paymentChannel.WECHAT_QRCODE":
    "WeChat QR Code Pay",
  "OrderManagement.payment-info.paymentChannel.WECHAT_WAP": "WeChat H5",
  "OrderManagement.payment-info.paymentChannel.GENERAL": "General Payment",
  "OrderManagement.payment-info.paymentId": "Payment Number",
  "OrderManagement.payment-info.paymentStatus.CLOSED": "Closed",
  "OrderManagement.payment-info.paymentStatus.FAIL": "Failed",
  "OrderManagement.payment-info.paymentStatus.FINISHED": "Finished",
  "OrderManagement.payment-info.paymentStatus.SUCCESS": "Successful",
  "OrderManagement.payment-info.payment_actual_paid_price": "Amount Paid",
  "OrderManagement.payment-info.status": "Payment Status",
  "OrderManagement.product-info": "Product Info",
  "OrderManagement.product-info.discount_amount": "Discount",
  "OrderManagement.product-info.modal.discount_amount": "Discount",
  "OrderManagement.product-info.modal.header": "Discount Details",
  "OrderManagement.product-info.modal.promotion_id": "Promo ID",
  "OrderManagement.product-info.modal.promotion_name": "Promo Name",
  "OrderManagement.product-info.modal.promotion_type": "Promo Type",
  "OrderManagement.product-info.modal.promotion_type.1": "Free Gift",
  "OrderManagement.product-info.modal.promotion_type.2": "Order Percentage Off",
  "OrderManagement.product-info.modal.promotion_type.3": "Order Amount Off",
  "OrderManagement.product-info.product-list": "Product List",
  "OrderManagement.product-info.quantity": "Quantity",
  "OrderManagement.product-info.sell_price": "Selling Price",
  "OrderManagement.product-info.sku_code": "SKU Code",
  "OrderManagement.product-info.sku_id": "SKU ID",
  "OrderManagement.product-info.sku_image": "SKU Image",
  "OrderManagement.product-info.spu_id": "Product ID",
  "OrderManagement.product-info.spu_name": "Product Name",
  "OrderManagement.product-info.spu_name.gift": "Gift",
  "OrderManagement.product-info.variation_attribute_list":
    "Variation Attribute",
  "OrderManagement.table.channel_name": "Channel",
  "OrderManagement.table.created_at": "Order Created",
  "OrderManagement.table.customer_id": "Customer ID",
  "OrderManagement.table.customer_name": "Customer Name",
  "OrderManagement.table.customer_phone_number": "Customer Phone",
  "OrderManagement.table.order_actual_paid_price": "Total Amount",
  "OrderManagement.table.order_id": "Order ID",
  "OrderManagement.table.status": "Order Status",
  "OrderManagement.table.storefront_name": "Storefront",
  "OrderManagement.table.tracking_number": "Tracking Number",
  "OrderManagement.title": "Orders",
  "OrderManagement.payment-info.paymentChannel.UNION_WEB":
    "UnionPay web payment",
  "OrderManagement.payment-info.paymentChannel.UNION_WAP":
    "UnionPay H5 payment",
  "OrderManagement.list.filter.presale.label": "Presale labels",
  "OrderManagement.list.filter.presale.option.presale": "Presale orders",
  "OrderManagement.list.filter.presale.option.normal": "Regular orders",
  "Product.Gift.create.title": "Create Gift",
  "Product.Gift.delete.failed.modal.title": "Delete Product Failed",
  "Product.Gift.detail.title": "Gift Details",
  "Product.Gift.disabled.failed.modal.content":
    "You can't disable or delete the gift as it has attended a not start/in progress/paused promotion. Please remove it from the promotion first.",
  "Product.Gift.disabled.failed.modal.title": "Failed to disable product",
  "Product.Gift.edit.title": "Edit Gift",
  "Product.Gift.enabled.failed.modal.title": "Failed to enable product",
  "Product.Gift.header.title": "Gift Management",
  "Product.Gift.list.header.notification":
    "Gift is a single variation product. It has no category and its sales price is 0. Only the enabled gift can be applied to promotion, and it cannot be searched and purchased in storefronts even if it's enabled.",
  "Product.Gift.list.title": "Gift List",
  "Product.Gift.title": "Gifts",
  "Product.NormalProduct.title": "Normal Products",
  "Product.Upload.verify-add": "Verify and Add",
  "Product.attribute.create.info.row1":
    "1. This list includes all the product attributes of the organization. Each attribute can be associated with multiple categories.",
  "Product.attribute.create.info.row2":
    "2. Deleting an attribute can not be restored. It will automatically disassociate this attribute from all the associated categories.",
  "Product.attribute.info.row1":
    "1. Product attribute specifies the product attributes that appear in the storefront when the product is accessed through a category. An example is the origin of a product.",
  "Product.attribute.info.row2":
    "2. By associating a product attribute to a category, it can be used to create a product. Note that a product attribute can be associated with multiple categories. Disassociate attributes from a category, doesn't affect existing products from the category.",
  "Product.attribute.modal.delete.info":
    "Are you sure you want to delete this variation attribute? The attribute will be deleted permanently and cannot be restored. It will be removed from all categories. Do you still want to delete it?",
  "Product.attribute.status": "Attribute Status",
  "Product.attribute.status.close": "Disabled",
  "Product.attribute.status.info":
    "Enabled product attributes can be used to create new products. Disable an attribute does not affect existing products.",
  "Product.attribute.status.open": "Enabled",
  "Product.attribute.table.column.operation.cancel-related.info.row1":
    "Are you sure you want to disassociate this product attribute? It will be unavailable for creating products under this category.",
  "Product.attribute.table.column.operation.cancel-related.info.row2":
    "Notice:",
  "Product.attribute.table.column.operation.cancel-related.info.row3":
    "1. If you need to use the attribute again, you can associate the product attribute with this category.",
  "Product.attribute.table.column.operation.cancel-related.info.row4":
    "2. Disassociating the attribute will not affect the products that have been created already.",
  "Product.attribute.value.add": "Add Attribute Value",
  "Product.attribute.value.name.placeholder": "Please input attribute value",
  "Product.category.attribute.action": "Associate Attribute",
  "Product.category.attribute.table.column.operation.show-in-channel.close.info":
    "After closing the display, customers will not be able to filter products through this attribute in the channel",
  "Product.category.attribute.table.column.operation.show-in-channel.open.info":
    "After the display is turned on, customers will be able to filter products through this attribute in the channel",
  "Product.category.basic.delete.modal.info":
    "After deleting the current category, it cannot be restored. Do you want to delete it?",
  "Product.category.basic.delete.modal.title": "Delete Category",
  "Product.category.basic.detail.edit.title": "Edit Category",
  "Product.category.basic.detail.header.last-update": "Last Updated",
  "Product.category.basic.detail.header.spu-num":
    "Number of Associated Products",
  "Product.category.basic.detail.header.status": "Status",
  "Product.category.basic.status": "Category Status",
  "Product.category.basic.status.disable": "Disabled",
  "Product.category.basic.status.enable": "Enabled",
  "Product.category.image.upload.tooltip.row1": "Add up to 5 classified images",
  "Product.category.image.upload.tooltip.row2": "Upload image file",
  "Product.category.image.upload.tooltip.row3":
    "1. The image must not exceed 5 MB",
  "Product.category.image.upload.tooltip.row4":
    "2. Supported image formats: bmp, jpg, jpeg, png, gif, svg, tiff",
  "Product.category.image.upload.tooltip.row5": "Add image link",
  "Product.category.image.upload.tooltip.row6":
    "Please ensure that the linked domain name has been added to the domainwhitelist before adding the image link",
  "Product.category.prev-cate.tooltip.row1":
    "1. Product categories support hierarchical parent & sub category relationship. Specify parent category here.",
  "Product.category.prev-cate.tooltip.row2":
    "2. Leave parent category blank for first-level category.",
  "Product.category.spu.create.btn.tooltip":
    "Create product under the current category.",
  "Product.category.spu.table.column.image.name": "Main Image",
  "Product.category.status.tooltip.row1":
    "Enabled: The category can be selected in the Storefront to display products under that category.",
  "Product.category.status.tooltip.row2":
    "Disabled: The category and sub-categories cannot be selected in the Storefront to display products in those categories. New products cannot be assigned to a disabled category.",
  "Product.category.title": "All Categories",
  "Product.category.tooltip.row1":
    "1. The category defines the variation attributes and attributes available for all the products associated with this category. Product categories can be shown in the Storefront for navigation and filtering.",
  "Product.category.tooltip.row2":
    "2. Product categories support an unlimited number of hierarchical levels. It's not recommended to create sub-categories deeper than 3 levels, as this makes it challenging to navigate to and search a product in the Storefront.",
  "Product.category.tree.drawer.scope-notification":
    "You can change the sorting by dragging",
  "Product.category.tree.sort.action": "Sort",
  "Product.category.tree.sort.top": "Top level category",
  "Product.category.variation.action": "Associate Variation Attribute",
  "Product.category.variation.table.column.operation.show-in-channel.close.info":
    "After closing the display, customers will not be able to filter products through this variation attribute in the channel",
  "Product.category.variation.table.column.operation.show-in-channel.open.info":
    "After the display is turned on, customers will be able to filter products through this variation attribute in the channel",
  "Product.classify.btn.confirm": "Confirm",
  "Product.classify.content.unselect.msg":
    "Please select a category on the left to edit",
  "Product.classify.header.action.btn.add": "Create Category",
  "Product.classify.header.action.btn.delete": "Delete This Category",
  "Product.classify.initial.empty":
    "There's currently no category. Please click here to create a new one.",
  "Product.classify.initial.modal.footer.btn.cancel": "Cancel",
  "Product.classify.initial.modal.footer.btn.confirm": "Save",
  "Product.classify.tabs.attribute.head.btn.related": "Associate Attribute",
  "Product.classify.tabs.attribute.modal.add": "Create Attribute",
  "Product.classify.tabs.attribute.modal.add-value": "Create Attribute Value",
  "Product.classify.tabs.attribute.modal.update": "Edit Attribute",
  "Product.classify.tabs.attribute.modal.update-value": "Edit Attribute Value",
  "Product.classify.tabs.attribute.modal.value.valid.empty":
    "Attribute value cannot be empty",
  "Product.classify.tabs.attribute.modal.value.valid.exist":
    "Attribute value already exists",
  "Product.classify.tabs.attribute.related.table.column.id": "Attribute ID",
  "Product.classify.tabs.attribute.related.table.column.name": "Name",
  "Product.classify.tabs.attribute.related.table.column.placeholder.name":
    "Please enter the attribute name",
  "Product.classify.tabs.attribute.remove.confirm":
    "Are you sure to delete this attribute?",
  "Product.classify.tabs.attribute.remove.title": "Delete Attributes",
  "Product.classify.tabs.attribute.table.column.attribute-value":
    "Attribute Value",
  "Product.classify.tabs.attribute.title": "Attributes",
  "Product.classify.tabs.attribute.un-related.confirm":
    "Are you sure to disassociate this attribute?",
  "Product.classify.tabs.attribute.un-related.title": "Disassociate Attributes",
  "Product.classify.tabs.basic.category.remove.confirm":
    "Are you sure to delete this category?",
  "Product.classify.tabs.basic.item.category-name": "Name",
  "Product.classify.tabs.basic.item.image": "Image",
  "Product.classify.tabs.basic.item.is-toggle-category": "Category Status",
  "Product.classify.tabs.basic.item.is-toggle-category.close": "Off",
  "Product.classify.tabs.basic.item.is-toggle-category.open": "On",
  "Product.classify.tabs.basic.item.name.validate.name-duplicate":
    "Sub-category name cannot be the same as the parent category or other sub-categories under the same parent category.",
  "Product.classify.tabs.basic.item.sub-headings": "Parent Category",
  "Product.classify.tabs.basic.title": "Basic Settings",
  "Product.classify.tabs.product.table.column.name": "Name",
  "Product.classify.tabs.property.related.table.column.required": "Required",
  "Product.classify.tabs.property.table.column.is-filter": "Filterable",
  "Product.classify.tabs.property.table.column.operation.un-related":
    "Disassociate",
  "Product.classify.tabs.related": "Associated successfully",
  "Product.classify.tabs.related.title": "Associated Products",
  "Product.classify.tabs.table.column.operation.delete.success":
    "Successfully Deleted",
  "Product.classify.tabs.table.column.operation.un-related.confirm.title":
    "Disassociate Product",
  "Product.classify.tabs.table.column.operation.un-related.confirm.warning":
    "Are you sure you want to disassociate this product?",
  "Product.classify.tabs.table.column.operation.un-related.success":
    "Successfully Disassociated",
  "Product.classify.tabs.variant.head.btn.add": "Create Variation Attribute",
  "Product.classify.tabs.variant.head.btn.related":
    "Associate Variation Attribute",
  "Product.classify.tabs.variant.modal.add-value":
    "Create Variation Attribute Value",
  "Product.classify.tabs.variant.modal.update": "Edit Variation Attribute",
  "Product.classify.tabs.variant.modal.update-value":
    "Edit Variation Attribute Value",
  "Product.classify.tabs.variant.modal.value.valid.empty":
    "Variation attribute value cannot be empty",
  "Product.classify.tabs.variant.modal.value.valid.exist":
    "Variation attribute value already exists",
  "Product.classify.tabs.variant.related.table.column.id":
    "Variation Attribute ID",
  "Product.classify.tabs.variant.related.table.column.name": "Name",
  "Product.classify.tabs.variant.related.table.column.placeholder.name":
    "Please enter the variation attribute name",
  "Product.classify.tabs.variant.remove.confirm":
    "Are you sure to delete this variation attribute?",
  "Product.classify.tabs.variant.remove.title": "Delete Variation Attributes",
  "Product.classify.tabs.variant.table.column.variant-value":
    "Variation Attribute Value",
  "Product.classify.tabs.variant.title": "Variation Attributes",
  "Product.classify.tabs.variant.un-related.confirm":
    "Are you sure to disassociate this variation attribute?",
  "Product.classify.tabs.variant.un-related.title":
    "Disassociate Variation Attributes",
  "Product.classify.tip.modal.title": "Warning",
  "Product.classify.title": "Product Categories",
  "Product.classify.variant.modal.form.name": "Name",
  "Product.classify.variant.modal.form.remark": "Remarks",
  "Product.classify.variant.modal.form.required": "If required",
  "Product.classify.variant.modal.form.required.false": "No",
  "Product.classify.variant.modal.form.required.true": "Yes",
  "Product.classify.variant.modal.form.status": "Status",
  "Product.classify.variant.modal.form.status.false": "Disabled",
  "Product.classify.variant.modal.form.status.true": "Enabled",
  "Product.detail.attribute.create.title": "Create Attribute",
  "Product.detail.attribute.edit.title": "Edit Attribute",
  "Product.detail.attribute.empty":
    "No attribute data, if you need to add a attribute, please add it in [Product Category-Attribute]",
  "Product.detail.attribute.empty.info":
    "Tip: There is no attribute associated with this category. If you need to add one, please add it to the category below.",
  "Product.detail.attribute.empty.text":
    "Please select at least one category before add attribute.",
  "Product.detail.attribute.no-more":
    "No variation attribute available. Please add it in [Product Category – Variation Attribute] or add a new category.",
  "Product.detail.attribute.tip.row1":
    "1. Product attributes are associated with the product category. You can select attributes under a category or create new ones.",
  "Product.detail.attribute.tip.row2":
    "2. Filling in the attributes accurately will help customers filter the product better.",
  "Product.detail.attribute.title": "Product Attribute (Optional)",
  "Product.detail.attribute.title.info":
    "Tip: There is an association relationship between attributes and categories. If you need to add specific attributes and parameters of the product, you need to select the corresponding category first, then select the attribute under the category, and set the required attribute value",
  "Product.detail.attribute.title.read": "Product Attribute",
  "Product.detail.basic.create.title": "Create Product",
  "Product.detail.basic.edit.title": "Edit Product",
  "Product.detail.basic.form.category-id.tip.row1":
    "1. Each product can be associated with multiple product categories",
  "Product.detail.basic.form.category-id.tip.row2":
    "2. Variation attributes and attributes are associated with the product categories. These attributes are available when creating products under the category.",
  "Product.detail.basic.form.category-ids": "Category",
  "Product.detail.basic.form.category-ids.empty": "Category cannot be empty",
  "Product.detail.basic.form.category-ids.placeholder":
    "Please select the categories",
  "Product.detail.basic.form.code.tip":
    "The product code stores the external ID of the product, such as the ERP code, inventory number, standard bar code, etc.",
  "Product.detail.basic.form.commodity-code": "Product Code",
  "Product.detail.basic.form.detail-images": "Product details-Images Only",
  "Product.detail.basic.form.detail-images.tip.row1":
    "1. This field supports image upload only. Please edit product details with the RTF editor.",
  "Product.detail.basic.form.detail-images.tip.row2":
    "2. Up to 10 images can be uploaded and the size of a single image must not exceed 5MB.",
  "Product.detail.basic.form.detail-images.tip.row3":
    "3. Only jpg, jpeg, png, gif, svg and tiff formats are supported.",
  "Product.detail.basic.form.detail-rich-text":
    "Product details-Rich Text Format (RTF)",
  "Product.detail.basic.form.detail-rich-text.tip.row1":
    "1. For the RTF editor, up to 30,000 characters including HTML tags can be inputted.",
  "Product.detail.basic.form.detail-rich-text.tip.row2":
    "2. Images in bmp, jpg, jpeg, png, gif, svg and tiff formats can be inserted.",
  "Product.detail.basic.form.detail-rich-text.tip.row3":
    "3. The size of a single image must not exceed 5MB and up to 20 images can be uploaded.",
  "Product.detail.basic.form.detail-rich-text.tip.row4":
    "4. When using hyperlinks/image links, make sure their domain names are on the white list and the HTTPS protocol is used.",
  "Product.detail.basic.form.detail-rich-text.tip.row5":
    "5. Please refer to the RTF part of the product details in the User Guide for information on use of HTML tags in the source.",
  "Product.detail.basic.form.image.tip.row1": "1. Supports up to 10 images.",
  "Product.detail.basic.form.image.tip.row2":
    "2. The size of a single image should not exceed 5 MB.",
  "Product.detail.basic.form.image.tip.row3":
    "3. Supported formats: bmp, jpg, jpeg, png, gif, svg, tiff.",
  "Product.detail.basic.form.image.tip.row4":
    "4. Adding image links only supports adding image links under whitelist domains.",
  "Product.detail.basic.form.images": "Product Images",
  "Product.detail.basic.form.images.valid.empty": "Image cannot be empty",
  "Product.detail.basic.form.materials": "Product Images and Videos",
  "Product.detail.basic.form.purchase-limit": "Purchase Limit",
  "Product.detail.basic.form.shelves-status": "Status",
  "Product.detail.basic.form.sub-title": "Product Description",
  "Product.detail.basic.form.title": "Product Name",
  "Product.detail.basic.form.title.tooltip":
    "You can search for product names, SPU codes and SKU codes. SPU codes and SKU codes must be entered in full.",
  "Product.detail.basic.form.video": "Product Video",
  "Product.detail.basic.form.video.attention.info.enum": {
    AVAILABLE: [
      "1. The main video has been successfully transcoded. You can see it in the product details",
      "2. If you need to replace this material, please delete the video and upload the new version",
    ],
    ERROR: [
      "1. The video must not be more than 60s long",
      "2. The video format must be 1:1 or 3:4",
      "3. The video bit rate must not exceed 2048 kbps/the video frame rate must not be greater than 60 fps",
    ],
    NONE: [
      "1. The video must not exceed 200MB or 60S; only MP4s are supported",
      "2. Only 1:1 or 3:4 videos are supported",
      "3. The video code rate must not exceed 2048 kbps/the video frame rate must not exceed 60 fps",
      "4. Videos larger than 200MB may only be uploaded via an external video link",
      "5. You may only choose one option: either local video file upload or external video link. To change the video upload option, delete the existing material before uploading again",
    ],
    TRANSCODING: [
      "1. The video in transcoding will not affect the product listing operation",
      "2. The video will not be displayed in external applications until the transcoding is complete",
      "3. The video cannot be edited while it is being transcoded. If you need to replace the video, please wait until the video transcoding is complete",
    ],
  },
  "Product.detail.basic.form.video.attention.title.enum": {
    AVAILABLE: "Note:",
    ERROR:
      "Failed to upload the video. Please check the following and upload again:",
    NONE: "Note:",
    TRANSCODING:
      "For security reasons, the video needs to be transcoded. During this period, you can continue to save the products and the system will automatically complete the transcoding operation:",
  },
  "Product.detail.basic.form.video.cover": "Video Cover",
  "Product.detail.basic.form.video.cover.tooltip.row1":
    "1. Up to one picture can be uploaded as the video cover image",
  "Product.detail.basic.form.video.cover.tooltip.row2":
    "2. This single picture must not exceed 5MB",
  "Product.detail.basic.form.video.cover.tooltip.row3":
    "3. Supported image formats: bmp, jpg, jpeg, png, gif, svg, tiff",
  "Product.detail.basic.form.video.link.action": "Check",
  "Product.detail.basic.form.video.link.title": "Add external video link",
  "Product.detail.basic.form.video.link.tooltip":
    "Note: Only whitelisted domain names are supported.Please configure whitelisted domain names in advance",
  "Product.detail.basic.form.video.link.validate":
    "The video link is not recognized, please contact the administrator to configure the whitelisted video links",
  "Product.detail.basic.form.video.tooltip.row1":
    "1. Supported format for the main video: MP4",
  "Product.detail.basic.form.video.tooltip.row2":
    "2. The main video must not exceed 200MB or be longer than 60S",
  "Product.detail.basic.form.video.tooltip.row3":
    "3. Up to one video can be uploaded as the main video",
  "Product.detail.basic.form.video.tooltip.row4":
    "4. The video format must be 1:1 or 3:4",
  "Product.detail.basic.form.video.tooltip.row5":
    "5. The video bit rate must not be greater than 2048 kbps",
  "Product.detail.basic.form.video.tooltip.row6":
    "6. The video frame rate must not be greater than 60 fps",
  "Product.detail.basic.form.video.tooltip.row7":
    "7. After it has been uploaded, the main video will automatically be transcoded. This will not affect the product listing",
  "Product.detail.basic.form.video.upload-failed": "Video upload failed",
  "Product.detail.basic.form.video.upload-success":
    "Video uploaded, transcoding",
  "Product.detail.basic.title": "Basic Information",
  "Product.detail.category.status.tip.row1":
    "1. Enabled: The product is available in the Storefront, and can be purchased.",
  "Product.detail.category.status.tip.row2":
    "2. Disabled: The product is not sellable, and is invisible in the Storefront. The product can only be edited by the merchant.",
  "Product.detail.detail.info.empty": "Product details cannot be empty",
  "Product.detail.edit.save.enable": "Save and Enable",
  "Product.detail.edit.save.enable.success":
    "The product is updated successfully and enabled.",
  "Product.detail.edit.save.sku": "Save and Create SKU",
  "Product.detail.edit.save.success": "Success",
  "Product.detail.edit.title": "Edit Product",
  "Product.detail.entry.shelve.useless":
    "Cannot modify enabled product. Please disable the product first",
  "Product.detail.external.attribute.action.title": "Add Attribute",
  "Product.detail.external.form.attributes": "Product Attributes",
  "Product.detail.external.form.attributes-holder": "Please select attributes",
  "Product.detail.external.form.attributes-value-holder":
    "Please select attributes value",
  "Product.detail.external.form.product-variant": "Variation Attribute",
  "Product.detail.external.form.product-variant-multiple":
    "Multiple Variations",
  "Product.detail.external.form.product-variant-single": "No Variation",
  "Product.detail.external.sku-list.title": "SKU List",
  "Product.detail.external.sku-list.valid.empty": "SKU list cannot be empty",
  "Product.detail.external.title": "Extended information",
  "Product.detail.external.variant.action.title": "Add Variation Attribute",
  "Product.detail.external.variant.modal.form.variant-holder":
    "Please select variant attributes",
  "Product.detail.external.variant.modal.form.variant-value-holder":
    "Please select variant attributes value",
  "Product.detail.external.variant.puzzle.batch-set.cost": "Cost Price",
  "Product.detail.external.variant.puzzle.batch-set.fill": "Setting",
  "Product.detail.external.variant.puzzle.batch-set.inventory":
    "Available to Sell",
  "Product.detail.external.variant.puzzle.batch-set.market": "Market Price",
  "Product.detail.external.variant.puzzle.batch-set.sell": "Selling Price",
  "Product.detail.external.variant.puzzle.batch-set.title": "Batch Settings",
  "Product.detail.external.variant.puzzle.batch-set.volume": "Volume(m³)",
  "Product.detail.external.variant.puzzle.batch-set.weight": "Weight(kg)",
  "Product.detail.external.variant.puzzle.table.cell.operation.clear": "Empty",
  "Product.detail.external.variant.puzzle.table.cell.operation.disable":
    "Disable",
  "Product.detail.external.variant.puzzle.table.cell.operation.enable":
    "Enable",
  "Product.detail.external.variant.puzzle.table.expand.column.sku-code":
    "SKU Code",
  "Product.detail.external.variant.puzzle.table.expand.column.sku-image":
    "SKU Image",
  "Product.detail.external.variant.puzzle.table.price.valid.max10":
    "The price length cannot exceed 10 characters",
  "Product.detail.external.variant.puzzle.table.sku-code.valid.error":
    "Only allows a combination of lower case letters, upper case letters, numbers, and underscores.",
  "Product.detail.external.variant.puzzle.table.summary.sku-length":
    "Number of SKUs: {num}",
  "Product.detail.external.variant.puzzle.table.valid.no-number":
    "The value is illegal",
  "Product.detail.external.variant.title": "Variation Attribute",
  "Product.detail.info.title": "Product details",
  "Product.detail.read.category.modal.title": "Edit Category",
  "Product.detail.read.sku.disabled.info":
    "There is no SKU information for the SPU, so it cannot be put on the shelves. Please go to 【Price and Inventory】 to create SKU information",
  "Product.detail.read.sku.empty.info":
    "There is no SKU data at present, please click the [Edit] button below to create an SKU",
  "Product.detail.read.status.action.disabled":
    "Disabled products will not be visible in the Storefront. Are you sure you want to disable this product?",
  "Product.detail.read.status.action.disabled.title": "Disable Product",
  "Product.detail.read.status.action.enabled":
    "Enabled products will be instantly available in the Storefront for purchase. Are you sure you want to enable this product?",
  "Product.detail.read.status.action.enabled.title": "Enable Product",
  "Product.detail.read.status.action.enabled.transcoding":
    "The product will be marketed. The product video is still being transcoded and cannot be displayed. You can still put the product on the market. After it is put on the market, the product will be displayed in the channel and the customer will be able to purchase the product. Is it on the market?",
  "Product.detail.read.status.action.prevent.row1":
    "This product cannot be enabled. Please check the following:",
  "Product.detail.read.status.action.prevent.row2":
    "1. Has the product SKU record been created?",
  "Product.detail.read.status.action.prevent.row3":
    "2. Is there at least one enabled SKU record?",
  "Product.detail.read.status.action.prevent.title": "Failed to enable product",
  "Product.detail.sku.batch-settings.dispatch.btn": "Batch Setting",
  "Product.detail.sku.batchSetting.tip.row1":
    "1. You can batch fill in SKU information by entering a value in batch settings;",
  "Product.detail.sku.batchSetting.tip.row2":
    "2. The disabled SKU will not be batch filled.",
  "Product.detail.sku.category": "Added Categories:",
  "Product.detail.sku.category.empty":
    "Please select at least one category before add variation attribute.",
  "Product.detail.sku.category.empty.btn": "Add category",
  "Product.detail.sku.cost_price.validate.max": "Exceeds the maximum value",
  "Product.detail.sku.create.title": "Create SKU",
  "Product.detail.sku.edit.title": "Edit SKU",
  "Product.detail.sku.inventory.validate.max": "Exceeds the maximum value",
  "Product.detail.sku.market_price.validate.max": "Exceeds the maximum value",
  "Product.detail.sku.multiple.validate.require":
    "This item cannot be 0 or negative",
  "Product.detail.sku.sell_price.validate.max": "Exceeds the maximum value",
  "Product.detail.sku.single.info":
    "Tip: Fill in the following form to create a single specification directly",
  "Product.detail.sku.sku_code.validate.max": "Exceeds the max length",
  "Product.detail.sku.table.title": "Price and Inventory",
  "Product.detail.sku.value.validate.digit": "Two digit decimal limited",
  "Product.detail.sku.variation": "Variation Attribute (Optional)",
  "Product.detail.sku.variation.empty":
    "No variation attribute available. Please add it in [Product Category- Variation Attribute].",
  "Product.detail.sku.variation.empty.info":
    "Tip: There is an association relationship between attributes and categories. If you need to add specific attributes of the product, you need to select the corresponding category first, then select the attribute under the category, and set the required attribute value.",
  "Product.detail.sku.variation.info":
    "Tip: If you need to create a product with multiple variations, you need to add variation attributes and create multiple SKUs. If you don’t add them, the single variation attribute will be the default.",
  "Product.detail.sku.variation.max-length":
    "Variation attribute has reached the upper limit",
  "Product.detail.sku.variation.no-more":
    "There is no variation attribute data at present. If you need to add a variation attribute, please add it in [Product category - Variation attribute] or add a new category.",
  "Product.detail.sku.variation.read": "Variation Attribute",
  "Product.detail.sku.variation.tip.row1":
    "1. Multi-variation products need to add the corresponding variation attribute. The permutation of various attribute combinations/SKUs will be automatically generated;",
  "Product.detail.sku.variation.tip.row2":
    "2. Each product supports up to 10 variation attributes;",
  "Product.detail.sku.variation.tip.row3":
    "3. Each product supports up to 200 variations.",
  "Product.detail.sku.volume.validate.max": "Exceeds the maximum value",
  "Product.detail.sku.weight.validate.max": "Exceeds the maximum value",
  "Product.detail.spu.create.success": "Created Successfully",
  "Product.detail.spu.status.last-update": "Last Updated",
  "Product.detail.spu.type.multiple": "Multiple Variations",
  "Product.detail.spu.type.none": "No Variation Attribute",
  "Product.detail.spu.type.single": "Single Variation",
  "Product.detail.spu.type.tip.row1":
    "1. Single Variation: the product has no variations or only one SKU.",
  "Product.detail.spu.type.tip.row2":
    "2. Multiple Variation: The product has one or more SKUs.",
  "Product.detail.spu.types": "Product Type",
  "Product.detail.spu.searchable-config": "Search Config",
  "Product.detail.spu.searchable-config.yes": "Searchable",
  "Product.detail.spu.searchable-config.no": "Unsearchable",
  "Product.detail.spu.searchable-config.tips.row1":
    "1. After a product is set to be unsearchable, it cannot be found at the search interface.",
  "Product.detail.spu.searchable-config.tips.row2":
    "2. Unsearchable products cannot be displayed in the product list under the category. They cannot be included in the product sorting either.",
  "Product.detail.spu.searchable-config.tips.row3":
    "3. If you open the product details page through the store interface, unsearchable products can be added to the shopping cart and an order can be placed.",
  "Product.detail.spu.current-status": "Current Listing Status",
  "Product.detail.spu.auto-online": "Automatic Listing:",
  "Product.detail.spu.auto-offline": "Automatic Delisting:",
  "Product.detail.spu.auto-online-time": "Automatic Listing Time",
  "Product.detail.spu.auto-offline-time": "Automatic Delisting Time",
  "Product.detail.spu.update.failed": "Updated failed",
  "Product.detail.spu.update.success": "Updated successfully",
  "Product.detail.title": "Create Product",
  "Product.management.header.add": "Create Product",
  "Product.management.header.date.down": "Product off-shelves date",
  "Product.management.header.date.up": "Product on-shelves date",
  "Product.management.header.reset": "Reset",
  "Product.management.header.search": "Filter",
  "Product.management.header.shelves.down": "Disabled",
  "Product.management.header.shelves.status": "Product Status",
  "Product.management.header.shelves.up": "Enabled",
  "Product.management.header.spu.disable": "Disabled",
  "Product.management.header.spu.enable": "Enabled",
  "Product.management.header.spu.edit-status": "Edit Listing/Delisting",
  "Product.management.header.title": "Product List",
  "Product.management.list.delete.confirm":
    "Are you sure you want to delete this product?",
  "Product.management.list.delete.title": "Delete Product",
  "Product.management.list.operation.edit.sku": "Edit SKU",
  "Product.management.list.operation.edit.spu": "Edit Product",
  "Product.management.list.search.name.placeholder": "Please enter keyword(s)",
  "Product.management.list.shelve.down.success": "Disabled successfully",
  "Product.management.list.shelve.up.success": "Enabled successfully",
  "Product.management.list.un-shelve.confirm":
    "Are you sure you want to disable the product?",
  "Product.management.table.column.product-action-delete": "Delete",
  "Product.management.table.column.product-action-edit": "Edit",
  "Product.management.table.column.product-action-preview": "Details",
  "Product.management.table.column.product-empty": "No data",
  "Product.management.table.column.product-id": "ID",
  "Product.management.table.column.product-image": "Main Image",
  "Product.management.table.column.product-inventory": "Available to Sell",
  "Product.management.table.column.product-sales": "Selling Price",
  "Product.management.table.column.product-shelves-time": "Enable/Disable",
  "Product.management.table.column.product-status": "Product Status",
  "Product.management.table.column.situation": "Situation",
  "Product.management.title": "Manage Products",
  "Product.preview.header.back-list": "Back to Product List",
  "Product.preview.table.filter.search.tooltip":
    "Product ID, Product Information, Product Review Content is searchable.Full information is required for ID search.",
  "Product.preview.title": "Product Details",
  "Product.property.modal.related.none.error":
    "Please select at least one item to related with",
  "Product.property.modal.search.placeholder": "Please enter keyword(s)",
  "Product.property.table.column.operation.cancel-related": "Disassociate",
  "Product.property.table.column.operation.show-in-channel.close":
    "Disable Filter",
  "Product.property.table.column.operation.show-in-channel.close.success":
    "Disabled",
  "Product.property.table.column.operation.show-in-channel.open":
    "Enable Filter",
  "Product.property.table.column.operation.show-in-channel.open.success":
    "Enabled",
  "Product.property.table.column.operation.show-in-channel.open.tip.row1":
    "1. In the Storefront, customers can filter products according to categories, variation attributes, and product attributes. The filterable statuses of the product attributes under the category are:",
  "Product.property.table.column.operation.show-in-channel.open.tip.row2":
    "Filterable: Customers can use product attributes to filter products in the Storefront",
  "Product.property.table.column.operation.show-in-channel.open.tip.row3":
    "Nonfilterable: Customers cannot use product attributes to filter products in the Storefront, but this does not affect the selection and ordering of SKUs",
  "Product.property.table.column.operation.show-in-channel.open.tip.row4":
    "2. You can enable/disable filtering using the [Enable Filter/Disable Filter] buttons.",
  "Product.property.table.column.show-in-channel":
    "Filterable in the Storefront",
  "Product.property.table.column.show-in-channel.shown": "Filterable",
  "Product.property.table.column.show-in-channel.un-show": "Nonfilterable",
  "Product.purchase-limit.edit.info":
    "Modifying the purchase limit rule only affects new orders and cannot change orders that have already been created by customer",
  "Product.purchase-limit.edit.title": "Edit Purchase Limit Rule",
  "Product.purchase-limit.rule": "Purchase Limit Rule",
  "Product.purchase-limit.status": "Purchase Limit Status",
  "Product.purchase-limit.status.disabled": "Disabled",
  "Product.purchase-limit.status.enabled": "Enabled",
  "Product.purchase-limit.variation": "Purchase Limit Type",
  "Product.purchase-limit.variation.sku": "SKU Purchase Limit",
  "Product.purchase-limit.variation.sku.column.title":
    "Purchase Limit Quantity",
  "Product.purchase-limit.variation.sku.disabled": "Disable",
  "Product.purchase-limit.variation.sku.enabled": "Enable",
  "Product.purchase-limit.variation.spu": "SPU Purchase Limit",
  "Product.purchase-limit.variation.union": "Per Person / Per Order",
  "Product.review.detail.header-actions.approve": "Approve",
  "Product.review.detail.header-actions.hide-display": "Hide",
  "Product.review.detail.header-actions.reject": "Reject",
  "Product.review.detail.header-actions.show-display": "Display",
  "Product.review.detail.header-details.channel-name": "Channel",
  "Product.review.detail.header-details.created-at": "Reviewed at",
  "Product.review.detail.header-details.customer-id": "Customer ID",
  "Product.review.detail.header-details.customer-name": "Customer Name",
  "Product.review.detail.header-details.order-no": "Order ID",
  "Product.review.detail.header-details.spu-id": "Product ID",
  "Product.review.detail.header-details.storefront-name": "Storefront",
  "Product.review.detail.review-content.basic": "Basic Info",
  "Product.review.detail.review-content.basic.content": "Content",
  "Product.review.detail.review-content.basic.review-display": "Display Status",
  "Product.review.detail.review-content.basic.score": "Score",
  "Product.review.detail.review-content.images": "Image",
  "Product.review.detail.reviewer.content": "Approved By: {name}",
  "Product.review.detail.reviewer.heading": "Approved By",
  "Product.review.detail.sku-info.basic": "Basic Info",
  "Product.review.detail.sku-info.basic.quantity": "Quantity",
  "Product.review.detail.sku-info.basic.sell-price": "Selling Price",
  "Product.review.detail.sku-info.basic.spu-id": "Product ID",
  "Product.review.detail.sku-info.basic.spu-name": "Product Name",
  "Product.review.detail.sku-info.basic.variation-attribute":
    "Variation Attribute",
  "Product.review.detail.sku-info.image": "SKU Image",
  "Product.review.detail.status.heading": "Approval Status",
  "Product.review.detail.tab.content": "Content",
  "Product.review.detail.tab.spu-info": "Product Information",
  "Product.review.detail.title": "Product Review Details",
  "Product.review.hooks.constant.approve.approved": "Approved",
  "Product.review.hooks.constant.approve.pending": "Unapproved",
  "Product.review.hooks.constant.approve.rejected": "Rejected",
  "Product.review.hooks.constant.review-display.hide": "Hidden",
  "Product.review.hooks.constant.review-display.visible": "Displayed",
  "Product.review.list.card-actions.approve": "Approve All",
  "Product.review.list.card-actions.reject": "Reject All",
  "Product.review.list.tab-label-all": "All",
  "Product.review.list.tab-label-pending": "Unapproved",
  "Product.review.list.table-columns.approve-status.title": "Approval Status",
  "Product.review.list.table-columns.channel-name.title": "Channel",
  "Product.review.list.table-columns.content.title": "Content",
  "Product.review.list.table-columns.created-at.title": "Reviewed at",
  "Product.review.list.table-columns.operation.approve": "Approve",
  "Product.review.list.table-columns.operation.hide-display": "Hide",
  "Product.review.list.table-columns.operation.reject": "Reject",
  "Product.review.list.table-columns.operation.show-display": "Display",
  "Product.review.list.table-columns.operation.visit-detail": "Details",
  "Product.review.list.table-columns.review-display.title": "Display Status",
  "Product.review.list.table-columns.score.title": "Score",
  "Product.review.list.table-columns.spu-id.title": "Product ID",
  "Product.review.list.table-columns.spu-info.sell-price":
    "Selling Price: {price}",
  "Product.review.list.table-columns.spu-info.title": "Product Information",
  "Product.review.list.table-columns.spu-info.variation-attribute":
    "Variation Attribute: {variationAttribute}",
  "Product.review.list.table-columns.storefront-name.title": "Storefront",
  "Product.review.list.table-control.approve-status.placeholder":
    "Approval Status",
  "Product.review.list.table-control.channel.placeholder": "Channel",
  "Product.review.list.table-control.compact-input.field.options.spu-id":
    "Product ID",
  "Product.review.list.table-control.compact-input.field.options.spu-name":
    "Product Name",
  "Product.review.list.table-control.compact-input.field.placeholder":
    "Filter by",
  "Product.review.list.table-control.compact-input.search-value.placeholder":
    "Please enter keyword",
  "Product.review.list.table-control.data-range.placeholder.end": "End time",
  "Product.review.list.table-control.data-range.placeholder.start":
    "Start time",
  "Product.review.list.table-control.review-display.placeholder":
    "Display Status",
  "Product.review.list.table-control.storefront.placeholder": "Storefront",
  "Product.review.list.title": "Product Reviews",
  "Product.review.prompt.approve.content":
    "Are you sure you want to approve the product review?",
  "Product.review.prompt.approve.title": "Approve",
  "Product.review.prompt.batchApprove.content":
    "Are you sure you want to batch approve {num} product review？",
  "Product.review.prompt.batchApprove.title": "Approve All",
  "Product.review.prompt.batchReject.content":
    "Product reviews cannot be set to display after failing review, are you sure you want to batch fail {num} product review?",
  "Product.review.prompt.batchReject.title": "Reject All",
  "Product.review.prompt.hide-display.content":
    "Product review will not be displayed in the Storefront after confirmation. Are you sure you want to hide it?",
  "Product.review.prompt.hide-display.title": "Hide",
  "Product.review.prompt.reject.content":
    "Product reviews cannot be set to display after failing review, are you sure you want to fail this review?",
  "Product.review.prompt.reject.title": "Reject",
  "Product.review.prompt.show-display.content":
    "Product review will be displayed in the Storefront after confirmation. Are you sure you want to display it?",
  "Product.review.prompt.show-display.title": "Display",
  "Product.situation.enum": {
    video: {
      AVAILABLE: "Normal",
      ERROR: "Transcoding failed",
      TRANSCODING: "Video transcoding",
    },
  },
  "Product.sku.status": "Status",
  "Product.sku.status.disabled": "Disabled",
  "Product.sku.status.enabled": "Enabled",
  "Product.title": "Products",
  "Product.variation.create.info.row1":
    "1. This list includes all the variation attributes of the organization. Each variation attribute can be associated with multiple categories.",
  "Product.variation.create.info.row2":
    "2. Deleting a variation attribute can not be restored. It will automatically disassociate this variation attribute from all the associated categories.",
  "Product.variation.info.row1":
    "1. Many products are available in various color and sizes. Variation attribute determines how a product varies. Multi-variation product refers to a SPU with multiple SKUs, and different SKUs have different variation attribute value, such as size and color combinations.",
  "Product.variation.info.row2":
    "2. By associating variation attributes to a category, the variation attribute can be used to create a product. Note that a variation attribute can be associated with multiple categories. Disassociate variation attributes from a category, doesn't affect existing products from the category.",
  "Product.variation.modal.delete.info":
    "Are you sure you want to delete this variation attribute? The variation attribute will be deleted permanently and cannot be restored. It will be removed from all categories. Do you still want to delete it?",
  "Product.variation.status": "Variation Attribute Status",
  "Product.variation.status.close": "Disabled",
  "Product.variation.status.info":
    "Enabled variation attributes can be used to create new products. Disable a variation attribute does not affect existing products.",
  "Product.variation.status.open": "Enabled",
  "Product.variation.table.column.operation.cancel-related.info.row1":
    "Are you sure you want to disassociate this variation attribute? It will not be available for creating products under this category.",
  "Product.variation.table.column.operation.cancel-related.info.row2":
    "Notice:",
  "Product.variation.table.column.operation.cancel-related.info.row3":
    "1. If you need to use the variation attribute again, you can associate the variation attribute with this category.",
  "Product.variation.table.column.operation.cancel-related.info.row4":
    "2. Disassociating the variation attribute will not affect products that have been created already.",
  "Product.variation.value.add": "Add Variation Attribute Value",
  "Product.variation.value.name.placeholder":
    "Please input variation attribute value",
  "Product.management.header.edit-sort": "Edit Sort",
  "Product.related-spu.sort-modal.page-sort-info":
    "You are editing the product sorting for the current page. Current page {pageSize} items/page    number: {pageNumber} products currently sorted: {startIndex}- {endIndex} items",
  "Product.detail.basic.form.default-position": "Sorting under category",
  "Product.detail.basic.form.default-position.top": "Pin to top",
  "Product.detail.basic.form.default-position.bottom": "Pin to bottom",
  "Product.presale.name": "Presale",
  "Product.management.list.operation.un-presale": "Cancel presale",
  "Product.management.list.operation.presale": "Set as presale product",
  "Product.management.un-presale.info":
    "Please confirm you want to set the presale status of this product to regular product",
  "Product.management.presale.info":
    "Please confirm product pre-sale information and submit changes",
  "Product.management.un-presale.time-up.enable":
    "Set to regular product and keep it enabled",
  "Product.management.un-presale.time-up.disable":
    "Set to regular product and keep it disabled",
  "Product.management.presale.schedule.time": "Presale time",
  "Product.management.presale.schedule.time-up.action": "After presale ends",
  "Product.management.presale.status": "Presale status",
  "Product.management.presale.status.normal.spu": "Regular product",
  "Product.management.presale.status.presale.spu": "Presale Product",
  "Product.management.inventory_min": "Minimum stock",
  "Product.management.inventory_max": "Maximum stock",
  "Product.presale.tips": [
    "Orders containing this product cannot be created before the presale starts.",
    "During presale, orders containing pre-sale products are presale orders",
    "Presale orders that have been created before presale ends will not be affected",
    "After presale, if products are set to regular products, all subsequent orders created will be regular orders",
  ],
  "Product.spu.tag-type.presale": "Product type",
  "Product.spu.basic.edit.enable.tip":
    "This product is currently listed. Editing it will affect its display in store.",
  "Promotion.detail.tab.discount.meta-info.tips":
    "If you set up multiple discount levels, a level will only take effect if conditions are met.",
  "Promotion.detail.tab.discount.selected-gift": "Select Gift",
  "Promotion.detail.tab.discount.table.granted_quantity": "Given Quantity",
  "Promotion.detail.tab.discount.table.granted_quantity.tips":
    "The quantity of this gift to give away after meeting the threshold amount.",
  "Promotion.detail.tab.discount.table.inventory": "Remaining Inventory",
  "Promotion.detail.tab.discount.table.name": "Product Name",
  "Promotion.detail.tab.discount.table.sku-id": "SKU ID",
  "Promotion.detail.tab.discount.table.sku-image": "SKU Image",
  "Promotion.details.header.type.value.amount-discount": "Order Amount Off",
  "Promotion.details.header.type.value.gift": "Free Gift",
  "Promotion.details.header.type.value.percentage-discount":
    "Order Percentage Off",
  "Promotion.details.headers.id": "Promotion ID",
  "Promotion.details.headers.name": "Promo Name",
  "Promotion.details.headers.product-range": "Participating Products",
  "Promotion.details.headers.status": "Status",
  "Promotion.details.headers.type": "Promo Type",
  "Promotion.details.tab.goods.notice.row1":
    "All products participated in this promotion.",
  "Promotion.details.tab.goods.notice.row2":
    "When all products participate in the event, this promotion will be effective for all enabled products, including products that have been disabled and then re-enabled or newly created enabled products.",
  "Promotion.details.tab.info.details": "Promotion Details",
  "Promotion.details.tab.info.name": "Promo Name",
  "Promotion.details.tab.info.product-range": "Participating Products",
  "Promotion.details.tab.info.remark": "Internal Notes",
  "Promotion.details.tab.info.rule": "Discount Rule",
  "Promotion.details.tab.info.rule.no-condition": "Free gift with any purchase",
  "Promotion.details.tab.info.rule.tmpl":
    "Over/Equal to {threshold} {type} free gift",
  "Promotion.details.tab.info.store": "Store",
  "Promotion.details.tab.info.time-scope": "Promotion Time",
  "Promotion.details.tab.info.type": "Condition Type",
  "Promotion.details.tabs.title.info": "Promotion Info",
  "Promotion.details.tabs.title.order-record": "Order Records",
  "Promotion.details.tabs.title.product-range": "Participating Products",
  "Promotion.details.tabs.title.rules": "Discount Details",
  "Promotion.details.title": "Promotion Details",
  "Promotion.list.colum.operation.close.modal.content":
    "Are you sure you want to close this promotion? It cannot be restored if closed. This will NOT affect the customers who have taken part in this promotion.",
  "Promotion.list.colum.operation.close.modal.title": "Close Promotion",
  "Promotion.list.colum.operation.delete.modal.content":
    "Are you sure you want to delete this promotion? Data cannot be restored after deletion, please proceed with caution.",
  "Promotion.list.colum.operation.delete.modal.title": "Delete Promotion",
  "Promotion.list.colum.operation.pause.modal.content":
    "Are you sure you want to pause this promotion? After pausing, the store will not be able to access data.",
  "Promotion.list.colum.operation.pause.modal.title": "Pause Promotion",
  "Promotion.list.colum.operation.start.modal.content":
    "Are you sure you want to start this promotion?",
  "Promotion.list.colum.operation.start.modal.title": "Start Promotion",
  "Promotion.list.column.label.name": "Promo Name",
  "Promotion.list.column.label.status": "Status",
  "Promotion.list.column.label.store": "Store",
  "Promotion.list.column.label.time": "Time",
  "Promotion.list.column.label.type": "Promo Type",
  "Promotion.list.column.operation.close": "Close",
  "Promotion.list.column.operation.pause": "Pause",
  "Promotion.list.column.operation.start": "Start",
  "Promotion.list.column.time.value.label.end": "Close:",
  "Promotion.list.column.time.value.label.start": "Start:",
  "Promotion.list.header.action.create": "Create",
  "Promotion.list.header.action.create.modal.content.type.amount-discount.desc":
    "X yuan off when you spend X yuan",
  "Promotion.list.header.action.create.modal.content.type.amount-discount.title":
    "Order Amount Off",
  "Promotion.list.header.action.create.modal.content.type.giving.desc":
    "Free gifts when you spend X yuan/unconditional",
  "Promotion.list.header.action.create.modal.content.type.giving.title":
    "Free Gift",
  "Promotion.list.header.action.create.modal.content.type.joint.desc": "拼团",
  "Promotion.list.header.action.create.modal.content.type.joint.title": "拼团",
  "Promotion.list.header.action.create.modal.content.type.percentage-discount.desc":
    "X% off when you spend X yuan",
  "Promotion.list.header.action.create.modal.content.type.percentage-discount.title":
    "Order Percentage Off",
  "Promotion.list.header.action.create.modal.title": "Select Promotion Type",
  "Promotion.list.header.statistical.count": "{count} items",
  "Promotion.list.toolbar.date.placeholder.end": "End Time",
  "Promotion.list.toolbar.date.placeholder.start": "Start Time",
  "Promotion.list.toolbar.input.name.placeholder": "Promo Name",
  "Promotion.list.toolbar.select.status.placeholder": "Status",
  "Promotion.list.toolbar.select.store.placeholder": "Store",
  "Promotion.list.toolbar.select.type.placeholder": "Promo Type",
  "Promotion.management.title": "Promotions",
  "Promotion.patch.create.title": "Create Promotion",
  "Promotion.patch.step.type.amount-discount.desc": "Order Amount Off",
  "Promotion.patch.step.type.giving.desc": "Free Gift",
  "Promotion.patch.step.type.percentage-discount.desc": "Order Percentage Off",
  "Promotion.patch.step1.form.date.label": "Promotion Time",
  "Promotion.patch.step1.form.date.label.valid.end":
    "The end time cannot be less than the start time",
  "Promotion.patch.step1.form.date.label.valid.start":
    "The start time cannot be less than the current time",
  "Promotion.patch.step1.form.date.label.valid.current":
    "The end time cannot be less than the current time",
  "Promotion.patch.step1.form.date.placeholder.end": "End Time",
  "Promotion.patch.step1.form.date.placeholder.start": "Start Time",
  "Promotion.patch.step1.form.date.tooltip": "The second level is set to 00",
  "Promotion.patch.step1.form.detail.label": "Promotion Details",
  "Promotion.patch.step1.form.detail.placeholder":
    "Please enter the promotion details (within 500 characters)",
  "Promotion.patch.step1.form.internal-remark": "Internal Notes",
  "Promotion.patch.step1.form.internal-remark.placeholder":
    "For internal use only, within 500 characters.",
  "Promotion.patch.step1.form.name.label": "Promotion Name",
  "Promotion.patch.step1.form.name.placeholder":
    "Please enter the promotion name (within 1-50 characters)",
  "Promotion.patch.step1.form.participation-limit": "Participation Limit",
  "Promotion.patch.step1.form.participation-limit.no-limit": "Unlimited",
  "Promotion.patch.step1.form.participation-limit.tips":
    "Unlimited by default. You can set a limit of up to 10 times.",
  "Promotion.patch.step1.form.participation-limit.tips.new":
    "New customers will participate in the event with their first order by default",
  "Promotion.patch.step1.form.participation-limit.tooltip":
    "The limit on how many times a customer ID can participate in the event.",
  "Promotion.patch.step1.form.store.label": "Applied Store",
  "Promotion.patch.step1.form.store.placeholder":
    "Please select (single choice)",
  "Promotion.patch.step1.form.target-customers": "Targeted Customers",
  "Promotion.patch.step1.form.target-customers.all": "All customers",
  "Promotion.patch.step1.form.target-customers.new": "New customers",
  "Promotion.patch.step1.form.target-customers.tooltip":
    "New customers: Customers who haven't completed an order. You can select this group when issuing new user gifts.",
  "Promotion.patch.step1.title": "Basic Information",
  "Promotion.patch.step2.form.all.product.modal.tip":
    "The product cannot be selected, as it is already associated with a mutually exclusive event.",
  "Promotion.patch.step2.form.discount.scope.tooltip.row1":
    "1. A store can only offer one X yuan off or X% off promotion applicable to all products at any one time.",
  "Promotion.patch.step2.form.discount.scope.tooltip.row2":
    "2. Only one X yuan off or X% off promotion per store is applicable to one product at any one time.",
  "Promotion.patch.step2.form.discount.scope.tooltip.row3":
    "3. If a product is associated with one X yuan off or X% off promotion applicable to all products and one X yuan off or X% off promotion applicable to some products at the same time, only the latter will be effective.",
  "Promotion.patch.step2.form.gift.product.action.add": "Add Product",
  "Promotion.patch.step2.form.gift.product.choose": "{count} selected",
  "Promotion.patch.step2.form.gift.product.label": "Select Product",
  "Promotion.patch.step2.form.gift.product.placeholder":
    "Please enter a product name",
  "Promotion.patch.step2.form.gift.product.category":
    "Please select a product category",
  "Promotion.patch.step2.form.gift.product.table.colum.id": "Product ID",
  "Promotion.patch.step2.form.gift.product.table.colum.image":
    "Product Main Image",
  "Promotion.patch.step2.form.gift.product.table.colum.name": "Product Name",
  "Promotion.patch.step2.form.gift.product.table.colum.operation.move":
    "Remove",
  "Promotion.patch.step2.form.gift.product.table.colum.sell_price":
    "Selling Price",
  "Promotion.patch.step2.form.gift.product.valid.empty":
    "Please select the product to participate in the promotion",
  "Promotion.patch.step2.form.gift.scope.item.all": "All Products",
  "Promotion.patch.step2.form.gift.scope.item.part": "Selected Products",
  "Promotion.patch.step2.form.gift.scope.label": "Participating Products",
  "Promotion.patch.step2.form.gift.scope.tooltip.row1":
    "1. There can be up to 5 gift promotions with all products participating at the same time in one store.",
  "Promotion.patch.step2.form.gift.scope.tooltip.row2":
    "2. A product can only be associated with one gift event with selected product participating per store at any one time.",
  "Promotion.patch.step2.submit.valid.modal.info.row1":
    "Detected {inValidSpus} selected products have been deleted or attended other exclusionary activities.",
  "Promotion.patch.step2.submit.valid.modal.info.row2":
    "* If you confirm, the following products will be removed automatically and the new list will be submitted. If you cancel, please remove manually in the selected product list.",
  "Promotion.patch.step2.submit.valid.modal.info.row3":
    "* When all the selected products are invalid, you need to select the participating products again.",
  "Promotion.patch.step2.submit.valid.modal.title": "Remove Product",
  "Promotion.patch.step2.title": "Participating Scope",
  "Promotion.patch.step3.gift-already-chosen-notification":
    "Some free gifts be used in multiple promotions during the event period, so some products may overlap. Please make sure that the promotion configuration matches event predictions to avoid giving away the same gift multiple times.",
  "Promotion.patch.step3.gift-already-chosen-notification.pormotion-name":
    "Promotion Name",
  "Promotion.patch.step3.form.rule-type": "Condition Type",
  "Promotion.patch.step3.form.rule-type.less.value": "No threshold",
  "Promotion.patch.step3.form.rule-type.pieces.value": "Quantity-based",
  "Promotion.patch.step3.form.rule-type.yuan.value": "Price-based",
  "Promotion.patch.step3.form.rules.content.amount-discount.input":
    "{discountAmount} yuan off",
  "Promotion.patch.step3.form.rules.content.amount-discount.valid":
    "Only 1–100,000 with 2 decimal places",
  "Promotion.patch.step3.form.rules.content.amount-discount.valid.than":
    "The deducted price must be less than the full price.",
  "Promotion.patch.step3.form.rules.content.discount.valid.than":
    "Discount levels must be incremental.",
  "Promotion.patch.step3.form.rules.content.gift.modal.notification.row1":
    "1. Only single-variant gifts that are enabled can be selected. Gifts associated with promotional activities (whether not started, in progress, or paused) cannot be disabled.",
  "Promotion.patch.step3.form.rules.content.gift.modal.notification.row2":
    "2. A gift can only be associated with one gift promotion per store at any one time. The gift cannot be selected because it is already associated with a mutually exclusive event.",
  "Promotion.patch.step3.form.rules.content.gift.modal.search.placeholder":
    "Please enter gift name",
  "Promotion.patch.step3.form.rules.content.gift.select-sku.action": "Add Gift",
  "Promotion.patch.step3.form.rules.content.gift.select-sku.count":
    "Up to 15, {skuCount} selected",
  "Promotion.patch.step3.form.rules.content.gift.select-sku.label":
    "Select Gift",
  "Promotion.patch.step3.form.rules.content.gift.select-sku.tooltip":
    "The quantity of this gift to give away after meeting the threshold amount.",
  "Promotion.patch.step3.form.rules.content.gift.select-sku.valid.max":
    "Only choose up to 15 gifts",
  "Promotion.patch.step3.form.rules.content.gift.table.column.count":
    "Given Quantity",
  "Promotion.patch.step3.form.rules.content.gift.table.column.count.required":
    "This item cannot be 0 or empty",
  "Promotion.patch.step3.form.rules.content.gift.table.column.count.valid.limit":
    "Only 1–10 integers",
  "Promotion.patch.step3.form.rules.content.gift.table.column.count.valid.max":
    "Cannot exceed remaining inventory",
  "Promotion.patch.step3.form.rules.content.gift.table.column.image":
    "SKU Image",
  "Promotion.patch.step3.form.rules.content.gift.table.column.inventory":
    "Remaining Inventory",
  "Promotion.patch.step3.form.rules.content.gift.table.column.name":
    "Product Name",
  "Promotion.patch.step3.form.rules.content.gift.table.column.operation.remove":
    "Remove",
  "Promotion.patch.step3.form.rules.content.gift.value": "Free Gift",
  "Promotion.patch.step3.form.rules.content.label": "Discount Content",
  "Promotion.patch.step3.form.rules.content.percentage-discount.input":
    "{discountPercentage} % off",
  "Promotion.patch.step3.form.rules.content.percentage-discount.valid":
    "Only 1–90 integers",
  "Promotion.patch.step3.form.rules.selectable-gift-amount":
    "Customer Manual Selection Limit",
  "Promotion.patch.step3.form.rules.selectable-gift-amount.tips":
    "If this option is not checked, all free gifts will be sent by default. If this option is checked, you can specify up to 5 pieces of free gifts. The specified number of free gifts must not exceed the number of selected free gifts.",
  "Promotion.patch.step3.form.rules.selectable-gift-amount.valid.limit":
    "The specified number of free gifts must not exceed the number of selected free gifts.",
  "Promotion.patch.step3.form.rules.threshold.gift.input": "Spend {price} yuan",
  "Promotion.patch.step3.form.rules.threshold.gift.valid":
    "Only 1-100000 with 2 decimal places",
  "Promotion.patch.step3.form.rules.threshold.label": "Discount Threshold",
  "Promotion.patch.step3.form.rules.threshold.pieces.input":
    "Buy {count} items",
  "Promotion.patch.step3.form.rules.threshold.pieces.valid":
    "Only 1-10000 integers",
  "Promotion.patch.step3.form.rules.threshold.valid.than":
    "Threshold number must be incremental.",
  "Promotion.patch.step3.save-as-draft": "Save as Draft",
  "Promotion.patch.step3.section": "Discount Rule",
  "Promotion.patch.step3.section.1": "Level 1",
  "Promotion.patch.step3.section.2": "Level 2",
  "Promotion.patch.step3.section.3": "Level 3",
  "Promotion.patch.step3.section.add.action.tip":
    "+ Add Discount Rules (up to three levels)",
  "Promotion.patch.step3.submit.valid.modal.info.row1":
    "Detected {inValidSkus} selected gifts that have been deleted or disabled or that participated in exclusionary activities.",
  "Promotion.patch.step3.submit.valid.modal.info.row2":
    "If you confirm, the following gifts will be removed automatically and the new list will be submitted. If you cancel, please remove manually in the selected gift list.",
  "Promotion.patch.step3.submit.valid.modal.title": "Remove Gift",
  "Promotion.patch.step3.title": "Discount Settings",
  "Promotion.patch.step3.tooltip":
    "If you set up multiple discount levels, a level will only take effect if conditions are met.",
  "Promotion.patch.step3.gift-already-chosen-modal.title": "Notification",
  "Promotion.patch.step3.gift-already-chosen-modal.msg":
    "Some free gifts may be used in multiple promotional activities during the event period, so there is a possibility of multiple giveaways. Do you want to save the event configuration?",
  "Promotion.patch.step3.gift-already-chosen-modal.radio-label":
    "Yes, I have checked the configuration and it is correct.",
  "Promotion.patch.update.title": "Edit Promotion",
  "Promotion.status.enum.CLOSED": "Closed",
  "Promotion.status.enum.DRAFT": "Draft",
  "Promotion.status.enum.IN_PROGRESS": "In Progress",
  "Promotion.status.enum.NOT_STARTED": "Not Started",
  "Promotion.status.enum.PAUSED": "Paused",
  "Promotion.title": "Promotions",
  "Promotion.toast.success.promotion.operation.close": "Closed",
  "Promotion.toast.success.promotion.operation.delete": "Deleted",
  "Promotion.toast.success.promotion.operation.pause": "Paused",
  "Promotion.toast.success.promotion.operation.start": "Started",
  "Promotion.toast.warning.promotion.in_progress":
    "Cannot edit while in progress, please pause first.",
  "Webhook.Webhook.table.send-status.title": "Send status",
  "Webhook.Webhook.table.send-status.title.abnormal": "Abnormal",
  "Webhook.Webhook.table.send-status.title.normal": "Normal",
  "Webhook.WebhookEdit.title": "Edit Webhook",
  "Webhook.WebhookList.action.add": "Create Webhook",
  "Webhook.WebhookList.checkWebhook.error":
    "The Remote Server returns an HTTP status code of 400",
  "Webhook.WebhookList.checkWebhook.success":
    "The Remote Server returned an HTTP status code of 200",
  "Webhook.WebhookList.deleteWebhook.error":
    "You need to disable this  before deleting ut",
  "Webhook.WebhookList.retryWebhook.success":
    "A manual retry request has been triggered",
  "Webhook.WebhookList.table.activated.isFalse": "Disable",
  "Webhook.WebhookList.table.activated.isTrue": "Enable",
  "Webhook.WebhookList.table.activated.title": "Status",
  "Webhook.WebhookList.table.lastTriggerAt.title": "Most Recent Sent Time",
  "Webhook.WebhookList.table.lastTriggerResult.title": "Latest trigger results",
  "Webhook.WebhookList.table.operation.changeActivatedTips":
    "Confirm {activated} the webhook?",
  "Webhook.WebhookList.table.operation.check": "Check",
  "Webhook.WebhookList.table.operation.deleteTips":
    "After deleting, the Webhook will not be recoverable, and the original events will not be pushed to the third-party platform. Are you sure to delete the Webhook?",
  "Webhook.WebhookList.table.operation.editTips":
    "The webhook needs to be disabled before editing. Are you sure you want to disable it?",
  "Webhook.WebhookList.table.operation.failedResend": "Resend Failed",
  "Webhook.WebhookList.table.operation.failedResend.failed": "Resend failed",
  "Webhook.WebhookList.table.operation.failedResend.success": "Resend success",
  "Webhook.WebhookList.table.operation.retry": "Retry",
  "Webhook.WebhookList.table.operation.retry.Prompt.title": "Webhook update",
  "Webhook.WebhookList.table.operation.retry.Prompt.validateError":
    "Start time / End time",
  "Webhook.WebhookList.title": "Webhooks",
  "Webhook.WebhookPost.HeaderAction.detail.modal.row1.desc":
    "The Webhook name can be named according to the Event Type and destination to improve readability.",
  "Webhook.WebhookPost.HeaderAction.detail.modal.row1.title": "Webhook Name:",
  "Webhook.WebhookPost.HeaderAction.detail.modal.row2.desc":
    "The Webhook Event Type represents the type of system events that triggers Webhook notifications. At present, the system includes the following Event Types: Customer order paid successfully, Order cancelled, and Customer order shipped. When a system event happens, the Webhook will trigger a payload of the corresponding Event Type, and the payload contains.",
  "Webhook.WebhookPost.HeaderAction.detail.modal.row2.title": "Event Type:",
  "Webhook.WebhookPost.HeaderAction.detail.modal.row3.desc":
    "After the Webhook is triggered, it pushes a callout notification to this HTTPS URL address.",
  "Webhook.WebhookPost.HeaderAction.detail.modal.row3.title": "URL:",
  "Webhook.WebhookPost.HeaderAction.detail.modal.row4.desc":
    "Webhook password/secret. It is used for webhook authentication. The request signature can be generated through the Webhook password / secret key for authentication to prevent the URL from malicious requests.",
  "Webhook.WebhookPost.HeaderAction.detail.modal.row4.title": "Secret:",
  "Webhook.WebhookPost.HeaderAction.detail.modal.row5.desc":
    "After setting up a Webhook, a health check will be performed against the target URL. Test JSON payload will be published to the specified URL. See a payload example below:",
  "Webhook.WebhookPost.HeaderAction.detail.modal.row5.title": "Check:",
  "Webhook.WebhookPost.HeaderAction.detail.modal.row6.desc":
    "When a Webhook is enabled, any event occurance for the corresponding Event Type, will trigger a Webhook callout notification.",
  "Webhook.WebhookPost.HeaderAction.detail.modal.row6.title": "Enable/Disable:",
  "Webhook.WebhookPost.RoutePrompt.message":
    "Cancel creation of Webhook event? Cancel will not save the edited data!",
  "Webhook.WebhookPost.ScopedNotification.row1": "Attention:",
  "Webhook.WebhookPost.ScopedNotification.row2":
    "1. Please fill in all required items according to the prompt. At the same time, the target address of the URL should be configured with the returned Response Status Code configured as 200 and the Response Body configured as Success. The URL can be recognized normally and the webhook can be saved normally;",
  "Webhook.WebhookPost.ScopedNotification.row3":
    "2. If the prompt fails to save, it indicates that the URL is unrecognized. Please check whether the URL is correct or the above configuration is incorrect;",
  "Webhook.WebhookPost.ScopedNotification.row4":
    "3. In case of configuration problems, click the help document to get more information.",
  "Webhook.WebhookPost.create.success": "Created successfully!",
  "Webhook.WebhookPost.pageHeaderAction.content.row_1":
    "Webhook Name: The webhook can be named according to the event type and destination to improve readability.",
  "Webhook.WebhookPost.pageHeaderAction.content.row_2":
    "Event Type: The webhook event type represents the type of system events that trigger webhook notifications. At present, the system includes the following event types: Customer order paid successfully; order canceled; and customer order shipped. When a system event happens, the webhook will trigger a payload of the corresponding event type, which contains the corresponding parameters.",
  "Webhook.WebhookPost.pageHeaderAction.content.row_3":
    "URL: After the webhook is triggered, it pushes a callout notification to this HTTPS URL address.",
  "Webhook.WebhookPost.pageHeaderAction.content.row_4":
    "Key: Webhook password/key, used for webhook authentication. The request signature can be generated through the webhook password/key for authentication to prevent the URL from malicious requests.",
  "Webhook.WebhookPost.pageHeaderAction.content.row_5":
    "Check: After setting up a Webhook, a health check will be performed against the target URL. Test JSON payload will be published to the specified URL. See a payload example below:",
  "Webhook.WebhookPost.pageHeaderAction.content.row_6":
    "Enable/Disable: When a Webhook is enabled, any event occurance for the corresponding Event Type, will trigger a Webhook callout notification.",
  "Webhook.WebhookPost.pageHeaderAction.title":
    "Webhook Operating Instructions",
  "Webhook.WebhookPost.test.link": "Go to Help Center",
  "Webhook.WebhookPost.test.result.failed":
    "Save Failure:The current status is {code}, return result from remote server is unexpected.",
  "Webhook.WebhookPost.test.result.failed.detail": "Check Return Result",
  "Webhook.WebhookPost.test.result.failed.info.correct": "Expected return:",
  "Webhook.WebhookPost.test.result.failed.info.in-correct":
    "Error return result:",
  "Webhook.WebhookPost.test.result.failed.title": "Result",
  "Webhook.WebhookPost.test.result.success":
    "Success:The Remote Server returned an HTTP status code of 200",
  "Webhook.WebhookPost.title": "Create Webhook",
  "Webhook.WebhookPost.update.success": "Updated successfully!",
  "Webhook.common.Webhook.custom-field.label": "Add Custom Data",
  "Webhook.common.Webhook.endpoint.label": "URL",
  "Webhook.common.Webhook.endpoint.placeholder": "Please enter URL",
  "Webhook.common.Webhook.endpoint.validateError":
    "Please enter a valid URL beginning with https. Supports 256 characters.",
  "Webhook.common.Webhook.event.label": "Event Type",
  "Webhook.common.Webhook.event.placeholder": "Select Event Type",
  "Webhook.common.Webhook.secret.label": "Key",
  "Webhook.common.Webhook.secret.placeholder": "Please enter the Key",
  "Webhook.common.Webhook.secret.validateError":
    "Please enter a 32 character string",
  "Webhook.common.Webhook.topic.label": "Webhook Name",
  "Webhook.common.Webhook.topic.placeholder": "Please enter a Webhook name",
  "Webhook.title": "Setup",
}
